/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 66);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendParamObjectToURL", function() { return appendParamObjectToURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendQueryStringToURL", function() { return appendQueryStringToURL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "assignWithDefaults", function() { return assignWithDefaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "binaryFind", function() { return binaryFind; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "camelCase", function() { return camelCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "capitalize", function() { return capitalize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clamp", function() { return clamp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "clone", function() { return clone; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compareNumbers", function() { return compareNumbers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compareStrings", function() { return compareStrings; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "composeAsync", function() { return composeAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "smartCompare", function() { return smartCompare; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepEqual", function() { return deepEqual; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepInclude", function() { return deepInclude; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "deepUnique", function() { return deepUnique; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "diffObjects", function() { return diffObjects; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "escapeRegExp", function() { return escapeRegExp; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "flatten", function() { return flatten; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatConjunction", function() { return formatConjunction; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatFileSize", function() { return formatFileSize; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "formatUSD", function() { return formatUSD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getLocale", function() { return getLocale; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "numberToLocaleString", function() { return numberToLocaleString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getIn", function() { return getIn; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "kebabCase", function() { return kebabCase; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isPromise", function() { return isPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isEmpty", function() { return isEmpty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadImage", function() { return loadImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "loadImages", function() { return loadImages; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapByID", function() { return mapByID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mapcat", function() { return mapcat; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "mergePropertiesWithDefaults", function() { return mergePropertiesWithDefaults; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "objFromQueryString", function() { return objFromQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "objToQueryString", function() { return objToQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "errorSensitiveFetch", function() { return errorSensitiveFetch; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "postJSON", function() { return postJSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "patchJSON", function() { return patchJSON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "ping", function() { return ping; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "poll", function() { return poll; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "precisionRound", function() { return precisionRound; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "randomInt", function() { return randomInt; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "range", function() { return range; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "request", function() { return request; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runAsync", function() { return runAsync; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeKeys", function() { return removeKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "removeEmptyKeys", function() { return removeEmptyKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "selectKeys", function() { return selectKeys; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "shuffle", function() { return shuffle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "stableSort", function() { return stableSort; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timeDifference", function() { return timeDifference; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "type", function() { return type; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "wait", function() { return wait; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "timeout", function() { return timeout; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "unique", function() { return unique; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "isFunction", function() { return isFunction; });
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

var appendParamObjectToURL = function appendParamObjectToURL(url, params) {
  return appendQueryStringToURL(url, objToQueryString(params));
};

var appendQueryStringToURL = function appendQueryStringToURL(url, queryString) {
  if (queryString === "") return url;

  var separator = url.includes("?") ? "&" : "?";

  return "" + url + separator + queryString;
};

// If any key in the `defaults` object doesn't exist in `target`, the key is
// merged. Additional `sources` object arguments are merged into `target`, but
// only the keys that exist in `defaults`.
var assignWithDefaults = function assignWithDefaults(target, defaults) {
  for (var _len = arguments.length, sources = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    sources[_key - 2] = arguments[_key];
  }

  Object.keys(defaults).forEach(function (key) {
    if (!target.hasOwnProperty(key) || target[key] === undefined) {
      target[key] = defaults[key];
    }

    sources.filter(function (source) {
      return source != null && source.hasOwnProperty(key) && source[key] !== undefined;
    }).forEach(function (source) {
      return target[key] = source[key];
    });
  });

  return target;
};

/**
 * Takes an ordered array and returns the first value where fn(value) returns true.
 */
var binaryFind = function binaryFind(arr, fn) {
  var high = arr.length + 1;
  var low = 0;
  while (low + 1 < high) {
    var mid = low + (high - low >> 1);
    if (fn(arr[mid])) {
      high = mid;
    } else {
      low = mid;
    }
  }

  return arr[high];
};

var camelCase = function camelCase(str) {
  var _ref = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
      _ref$isSuffix = _ref.isSuffix,
      isSuffix = _ref$isSuffix === undefined ? false : _ref$isSuffix;

  return str.split(/[-_]/g).map(function (part, i) {
    return i === 0 && !isSuffix ? part.toLowerCase() : capitalize(part.toLowerCase());
  }).join("");
};

var capitalize = function capitalize(str) {
  if (str === "") return str;

  return "" + str[0].toUpperCase() + str.slice(1);
};

var clamp = function clamp(x, a, b) {
  if (a > b) {
    return clamp(x, b, a);
  }

  if (x < a) {
    return a;
  }

  if (x > b) {
    return b;
  }

  return x;
};

var clone = function clone(obj) {
  if (obj === undefined) return undefined;

  return JSON.parse(JSON.stringify(obj));
};

var compareNumbers = function compareNumbers(a, b) {
  if (a == null && b == null) return 0;else if (a == null) return -1;else if (b == null) return 1;

  return a - b;
};

var compareStrings = function compareStrings(a, b) {
  return (a || "").trim().toLowerCase().localeCompare((b || "").trim().toLowerCase());
};

/**
 * Composes functions such that any returned Promise is resolved before the next invocation.
 * @param  {Function[]} funcs - A list of potentially async functions that each take a single param. Any null/
 * undefined values are ignored.
 */
var composeAsync = function composeAsync() {
  for (var _len2 = arguments.length, funcs = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    funcs[_key2] = arguments[_key2];
  }

  return function (arg) {
    var res = Promise.resolve(arg);

    var _loop = function _loop(i) {
      var f = funcs[i];
      if (f == null) {
        return "continue";
      }
      res = res.then(function (arg) {
        return f(arg);
      });
    };

    for (var i = funcs.length - 1; i >= 0; i--) {
      var _ret = _loop(i);

      if (_ret === "continue") continue;
    }
    return res;
  };
};

var smartCompare = function smartCompare(a, b) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$reverse = _ref2.reverse,
      reverse = _ref2$reverse === undefined ? false : _ref2$reverse;

  if (a === b) return 0;
  if (type(a) !== type(b) && b != null && a != null) {
    throw new Error("Don't know how to compare type " + type(a) + " with type " + type(b) + "!");
  }
  var compareType = a != null ? type(a) : type(b);

  var _ref3 = reverse ? [b, a] : [a, b],
      _ref4 = _slicedToArray(_ref3, 2),
      valueA = _ref4[0],
      valueB = _ref4[1];

  switch (compareType) {
    case "string":
      return compareStrings(valueA, valueB);
    case "number":
      return compareNumbers(valueA, valueB);
    default:
      // TODO(oscar): Add more types for comparison such as Dates.
      throw new Error("Missing method for comparing type " + compareType);
  }
};

/**
 * Recursively compares 2 JS objects.
 * @param {any} a
 * @param {any} b
 * @param {Object} options
 * @param {boolean} options.toJSON - Uses clone() in order to compare objects as
 * their JSON representations.
 * Useful when comparing plain objects to class instances.
 */
var deepEqual = function deepEqual(a, b) {
  var _ref5 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref5$toJSON = _ref5.toJSON,
      toJSON = _ref5$toJSON === undefined ? false : _ref5$toJSON;

  if (a === b) {
    return true;
  }

  var compareA = toJSON ? clone(a) : a;
  var compareB = toJSON ? clone(b) : b;
  var tA = type(compareA);
  var tB = type(compareB);

  if (tA === "array" && tB === "array") {
    if (compareA.length !== compareB.length) return false;

    for (var i = 0; i < compareA.length; i++) {
      if (!deepEqual(compareA[i], compareB[i])) return false;
    }

    return true;
  }

  if (tA === "set" && tB === "set") {
    if (compareA.size !== compareB.size) return false;

    var bShallowCopy = new Set(compareB);
    var _iteratorNormalCompletion = true;
    var _didIteratorError = false;
    var _iteratorError = undefined;

    try {
      aLoop: for (var _iterator = compareA[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
        var aElement = _step.value;

        // First check if there's an equivalent reference in the two sets before checking for deep equality,
        // since the latter is very inefficient.
        if (bShallowCopy.has(aElement)) {
          bShallowCopy.delete(aElement);
          continue;
        }

        var _iteratorNormalCompletion2 = true;
        var _didIteratorError2 = false;
        var _iteratorError2 = undefined;

        try {
          for (var _iterator2 = bShallowCopy[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
            var bElement = _step2.value;

            if (deepEqual(aElement, bElement)) {
              bShallowCopy.delete(bElement);
              continue aLoop;
            }
          }
        } catch (err) {
          _didIteratorError2 = true;
          _iteratorError2 = err;
        } finally {
          try {
            if (!_iteratorNormalCompletion2 && _iterator2.return) {
              _iterator2.return();
            }
          } finally {
            if (_didIteratorError2) {
              throw _iteratorError2;
            }
          }
        }

        return false;
      }
    } catch (err) {
      _didIteratorError = true;
      _iteratorError = err;
    } finally {
      try {
        if (!_iteratorNormalCompletion && _iterator.return) {
          _iterator.return();
        }
      } finally {
        if (_didIteratorError) {
          throw _iteratorError;
        }
      }
    }

    return true;
  }

  if (tA === "object" && tB === "object") {
    for (var k in compareA) {
      if (!(k in compareB)) return false;
    }

    for (var _k in compareB) {
      if (!(_k in compareA) || !deepEqual(compareA[_k], compareB[_k])) return false;
    }

    return true;
  }

  return compareA === compareB;
};

var deepInclude = function deepInclude(parent, child) {
  if (type(parent.some) === "function") {
    return parent.some(function (obj) {
      return deepEqual(obj, child);
    });
  } else if (type(parent) === "object") {
    return Object.values(parent).some(function (obj) {
      return deepEqual(obj, child);
    });
  }
  return false;
};

var deepUnique = function deepUnique(arr) {
  var index = 0;

  var _loop2 = function _loop2() {
    var item = arr[index];
    arr = arr.slice(0, index + 1).concat(arr.slice(index).filter(function (currItem) {
      return !deepEqual(item, currItem);
    }));
    index += 1;
  };

  while (index < arr.length) {
    _loop2();
  }

  return arr;
};

/**
 * @param {Object} a
 * @param {Object} b
 * @param {boolean} includeAKeys
 * @returns {Object} - An object containing keys in `b` if the values differ
 * from those in `a`. If `includeAKeys` is true, the keys in `a` that are NOT in
 * `b` are also included.
 */
var diffObjects = function diffObjects(a, b) {
  var includeAKeys = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;

  var result = {};
  for (var k in b) {
    if (!deepEqual(a[k], b[k])) {
      result[k] = b[k];
    }
  }
  if (includeAKeys) {
    for (var _k2 in a) {
      if (!(_k2 in b)) {
        result[_k2] = null;
      }
    }
  }

  return result;
};

// https://stackoverflow.com/questions/3446170/escape-string-for-use-in-javascript-regex
var escapeRegExp = function escapeRegExp(str) {
  return str.replace(/[-[\]/{}()*+?.\\^$|]/g, "\\$&");
};

var flatten = function flatten(arr) {
  return [].concat.apply([], arr);
};

/**
 * Takes a list of words and joins them via coordinating conjunction grammar rules. Oxford comma is mandatory.
 * @param {String[]} words
 */
var formatConjunction = function formatConjunction(words) {
  var conjunction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "and";

  var wc = words.length;
  if (wc <= 2) {
    return words.join(" " + conjunction + " ");
  } else {
    return [].concat(_toConsumableArray(words.slice(0, wc - 1)), [conjunction + " " + words[wc - 1]]).join(", ");
  }
};

var formatFileSize = function formatFileSize(size) {
  // NOTE: Math.log10 is not available in every browser and Math.log / Math.LN10
  // is unreliable.
  var thousands = Math.floor((("" + size).length - 1) / 3);
  return "" + Math.round(size / Math.pow(10, 3 * thousands)) + "BKMGTP"[thousands];
};

var formatUSD = function formatUSD(val) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  options = Object.assign({
    style: "currency",
    currency: "USD"
  }, options);

  return type(val) !== "number" ? null : val.toLocaleString("en", options);
};

var getLocale = function getLocale() {
  var _window = window,
      navigator = _window.navigator;

  if (navigator == null) return null;
  return navigator.languages && navigator.languages.length ? navigator.languages[0] : navigator.language;
};

/**
 * This function is a wrapper for Number.toLocalString() however it tries to use
 * the device's language. If all else fails, it uses "en".
 *
 * TODO(oscar): Fix the Intl polyfill we use, so there's no issue using
 * `undefined` as the locale.
 */
var numberToLocaleString = function numberToLocaleString(n, options, locale) {
  var f = function f(locale) {
    try {
      return Number(n).toLocaleString(locale, options);
    } catch (e) {}
  };
  return f(locale) || f() || f(getLocale()) || f("en");
};

var getIn = function getIn(m, ks, d) {
  if (m == null) return d;
  if (ks.length === 1) {
    return m[ks[0]];
  }

  return getIn(m[ks[0]], ks.slice(1));
};

var kebabCase = function kebabCase(str) {
  // A "-" will be inserted before every capital letter, so make sure the first
  // character isn't capitalized.
  str = str.charAt(0).toLowerCase() + str.slice(1);
  // Convert camel case to kebab case.
  str = str.replace(/[A-Z]/g, "-$&").toLowerCase();
  // Convert snake case to kebab case.
  str = str.replace(/_/g, "-");

  return str;
};

var isPromise = function isPromise(obj) {
  return Promise.resolve(obj) === obj;
};

var isEmpty = function isEmpty(obj) {
  return obj == null || Object.keys(obj).length === 0 &&
  // Needed for iterables like `Set`.
  Array.from(obj).length === 0 && (obj.size || 0) === 0;
};

var loadImage = function loadImage(url) {
  var crossOrigin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (!url) return Promise.reject(new Error("No image URL provided"));

  return new Promise(function (resolve, reject) {
    var img = new Image();
    img.crossOrigin = crossOrigin;
    img.addEventListener("load", function () {
      return resolve(img);
    });
    img.addEventListener("error", reject);
    img.src = url;
    if (img.complete) {
      resolve(img);
    }
  });
};

var loadImages = function loadImages(urls) {
  var crossOrigin = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
  return Promise.all(urls.filter(function (url) {
    return url != null;
  }).map(function (url) {
    return loadImage(url, crossOrigin);
  }));
};

var mapByID = function mapByID(arr) {
  var fn = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  return arr.reduce(function (map, item) {
    map[item.id] = fn != null ? fn(item) : item;
    return map;
  }, {});
};

var mapcat = function mapcat(arr, fn) {
  return [].concat.apply([], arr.map(fn));
};

// Like `Object.assign`, merges subsequent object arguments into the first
// object argument `defaults`, but only keys that exist in `defaults`.
// Unlike `Object.assign`, does not modify the first argument, but returns a
// shallow clone instead.
var mergePropertiesWithDefaults = function mergePropertiesWithDefaults(defaults) {
  for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
    args[_key3 - 1] = arguments[_key3];
  }

  if (args.length === 0) return defaults;

  var target = Object.assign(defaults);
  var keys = Object.keys(target);

  args.forEach(function (source) {
    if (source == null) return;

    keys.forEach(function (key) {
      if (source.hasOwnProperty(key) && source[key] !== undefined) {
        target[key] = source[key];
      }
    });
  });

  return target;
};

var objFromQueryString = function objFromQueryString() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : location.search.slice(1);

  return str.split("&").reduce(function (acc, part) {
    var _part$split$map = part.split("=", 2).map(decodeURIComponent),
        _part$split$map2 = _slicedToArray(_part$split$map, 2),
        key = _part$split$map2[0],
        value = _part$split$map2[1];

    if (key != null && value != null) {
      acc[key] = value;
    }

    return acc;
  }, {});
};

var objToQueryString = function objToQueryString(obj) {
  return Object.keys(obj).filter(function (key) {
    return obj[key] != null;
  }).map(function (key) {
    return encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]);
  }).join("&");
};

/**
 * Given a `Promise` that should resolve with a `Response` (e.g. a `Promise` returned by `fetch`), returns
 * a new Promise that will reject if 1) the original `Promise` rejects, 2) the original `Promise` resolves
 * with something that's not a `Response`, or 3) the original response had an error status.
 */
var wrapResponsePromise = function wrapResponsePromise(responsePromise) {
  return new Promise(function (resolve, reject) {
    return responsePromise.then(function (response) {
      if (!(response instanceof Response && response.ok)) {
        reject(response);
        return;
      }

      resolve(response);
    }).catch(reject);
  });
};

/**
 * Like `fetch` but returns a `Promise` that rejects if `!response.ok`. This allows calling code to handle
 * non-ok responses (e.g. 404s and 500s) using `Promise.catch`.
 */
var errorSensitiveFetch = function errorSensitiveFetch() {
  return wrapResponsePromise(fetch.apply(undefined, arguments));
};

var postJSON = function postJSON(url, json, options) {
  return makeJSONRequest(url, json, "POST", options);
};

var patchJSON = function patchJSON(url, json, options) {
  return makeJSONRequest(url, json, "PATCH", options);
};

/**
 * Sends a `fetch` request to `url` using the given `method` (e.g. "GET", "POST", "PATCH") and returns a
 * `Promise` that resolves with a `Response`. If `options.rejectOnErrorResponse === true`, the returned
 * `Promise` will reject if the sever returns an error response.
 */
function makeJSONRequest(url, json, method) {
  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
  var _options$rejectOnErro = options.rejectOnErrorResponse,
      rejectOnErrorResponse = _options$rejectOnErro === undefined ? false : _options$rejectOnErro;

  var fetchPromise = fetch(url, {
    body: JSON.stringify(json),
    credentials: "same-origin",
    headers: { "Content-Type": "application/json; charset=utf-8" },
    method: method
  });
  if (!rejectOnErrorResponse) {
    return fetchPromise;
  }
  return wrapResponsePromise(fetchPromise);
}

var ping = function ping(url) {
  var img = new Image();
  img.src = url;
};

// Polls a `url` for up to `timeoutMS`. Assumes the response is a JSON object
// with keys { state, value } where the values for `state` are one of
// ["success", "failed", "timeout"].
var poll = function poll(url, timeoutMS) {
  var timedOut = false;
  setTimeout(function () {
    return timedOut = true;
  }, timeoutMS);

  var request = function request() {
    if (timedOut) {
      return Promise.reject(new Error("poll exceeded timeout duration"));
    }

    return fetch(url, { credentials: "same-origin" }).then(function (response) {
      return response.json();
    }).then(function (_ref6) {
      var state = _ref6.state,
          value = _ref6.value;

      switch (state) {
        case "success":
          return value;
        case "failed":
          throw new Error("poll received failed response with value: " + value);
        case "timeout":
          return request();
        default:
          throw new Error("poll received response with unknown state: " + state);
      }
    });
  };

  return request();
};

var precisionRound = function precisionRound(number, precision) {
  var factor = Math.pow(10, precision);

  return Math.round(number * factor) / factor;
};

var randomInt = function randomInt(low, high) {
  return low + Math.floor(Math.random() * (high - low));
};

// Returns an array of integers from [start, stop) (i.e. exclusive of stop).
// Special case: if start === stop, return array with start as the only
// element.
var range = function range(start, stop) {
  var step = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

  if (start === stop) return [start];

  if (stop - start < 0 !== step < 0) {
    throw new Error("Invalid call to range: range(" + start + ", " + stop + ", " + step + ")");
  }

  return Array((stop - start) / step | 0).fill(null).map(function (_, i) {
    return start + i * step;
  });
};

var request = function request(method, url) {
  var headers = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
  var body = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  return new Promise(function (resolve, reject) {
    var req = new XMLHttpRequest();
    req.onreadystatechange = function () {
      if (req.readyState === 4 && req.status === 200) {
        resolve(req);
      }
    };
    req.addEventListener("load", resolve.bind(null, req));
    req.addEventListener("error", reject.bind(null, req));
    req.open(method.toUpperCase(), url);
    Object.keys(headers).forEach(function (key) {
      req.setRequestHeader(key, headers[key]);
    });
    req.send(body);
  });
};

var runAsync = function runAsync(fn) {
  setTimeout(fn, 0);
};

var removeKeys = function removeKeys(source, keys) {
  if (source == null) return {};

  return Object.keys(source).filter(function (key) {
    return !keys.includes(key);
  }).reduce(function (target, key) {
    target[key] = source[key];

    return target;
  }, {});
};

/** Remove keys if their value is empty.  */
var removeEmptyKeys = function removeEmptyKeys(source) {
  return selectKeys(source, function (_, val) {
    return !isEmpty(val);
  });
};

var selectKeys = function selectKeys(source, keys) {
  if (source == null) return {};

  switch (type(keys)) {
    case "array":
      return keys.reduce(function (target, key) {
        if (source.hasOwnProperty(key)) {
          target[key] = source[key];
        }

        return target;
      }, {});
    case "function":
      return Object.keys(source).reduce(function (target, key) {
        if (keys(key, source[key])) {
          target[key] = source[key];
        }

        return target;
      }, {});
  }
};

/**
 * Reorders items randomly into a new Array.
 * @param {Iterable} arr
 * @returns {Array}
 */
var shuffle = function shuffle(arr) {
  var result = [].concat(_toConsumableArray(arr));
  for (var i = result.length - 1; i > 0; i--) {
    var j = Math.floor(Math.random() * (i + 1));
    var _ref7 = [result[j], result[i]];
    result[i] = _ref7[0];
    result[j] = _ref7[1];
  }
  return result;
};

// Like `Array.sort()`, but maintains the relative order of array items with
// equal sort values and does not mutate the original array.
var stableSort = function stableSort(arr, sortFn) {
  var index = arr.reduce(function (agg, item, i) {
    agg.set(item, i);

    return agg;
  }, new Map());

  return arr.slice().sort(function (a, b) {
    return sortFn(a, b) || index.get(a) - index.get(b);
  });
};

var timeDifference = function timeDifference(a, b) {
  var msPerSecond = 1000,
      msPerMinute = msPerSecond * 60,
      msPerHour = msPerMinute * 60,
      msPerDay = msPerHour * 24,
      msPerWeek = msPerDay * 7,
      msPerMonth = msPerWeek * 4,
      msPerYear = msPerMonth * 13,
      elapsed = Math.abs(a - b);
  if (a <= b && elapsed < 1000 * 10) {
    return "just now";
  } else {
    var val = void 0,
        units = void 0;
    if (elapsed < msPerMinute) {
      val = Math.round(elapsed / msPerSecond);
      units = "second";
    } else if (elapsed < msPerHour) {
      val = Math.round(elapsed / msPerMinute);
      units = "minute";
    } else if (elapsed < msPerDay) {
      val = Math.round(elapsed / msPerHour);
      units = "hour";
    } else if (elapsed < msPerWeek) {
      val = Math.round(elapsed / msPerDay);
      units = "day";
    } else if (elapsed < msPerMonth) {
      val = Math.round(elapsed / msPerWeek);
      units = "week";
    } else if (elapsed < msPerYear) {
      val = Math.round(elapsed / msPerMonth);
      units = "month";
    } else {
      val = Math.round(elapsed / msPerYear);
      units = "year";
    }

    return [val, "" + units + (val === 1 ? "" : "s"), a < b ? "ago" : "from now"].join(" ");
  }
};

var type = function type(object) {
  return {}.toString.call(object).match(/\s([a-zA-Z]+)/)[1].toLowerCase();
};

/** Returns a Promise that resolves after `ms` ms. */
var wait = function wait(ms) {
  return new Promise(function (resolve) {
    setTimeout(resolve, ms);
  });
};

/** Returns a Promise that rejects after `ms` ms. */
var timeout = function timeout(ms) {
  return new Promise(function (_, reject) {
    setTimeout(function () {
      return reject(new Error("Promise timed out after " + ms + "ms"));
    }, ms);
  });
};

var unique = function unique(arr) {
  return arr.filter(function (el, i) {
    return arr.indexOf(el) === i;
  });
};

var isFunction = function isFunction(object) {
  return type(object) === "function";
};

/***/ }),

/***/ 1:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "addOneTimeListener", function() { return addOneTimeListener; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "animationEndPromise", function() { return animationEndPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "transitionEndPromise", function() { return transitionEndPromise; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "runTransitionSequence", function() { return runTransitionSequence; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendChildren", function() { return appendChildren; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "copyToClipboard", function() { return copyToClipboard; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createElement", function() { return createElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "empty", function() { return empty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fetchHTML", function() { return fetchHTML; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "firstAncestor", function() { return firstAncestor; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "fragmentFromString", function() { return fragmentFromString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "forceReflow", function() { return forceReflow; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "generateSnippetMap", function() { return generateSnippetMap; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getCSSProperty", function() { return getCSSProperty; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getElementsByClass", function() { return getElementsByClass; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getRelativeBoundingClientRect", function() { return getRelativeBoundingClientRect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getAggregateBoundingClientRect", function() { return getAggregateBoundingClientRect; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFontSizeToFit", function() { return getFontSizeToFit; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "getFontSizeToFitLines", function() { return getFontSizeToFitLines; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "indexOf", function() { return indexOf; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "imageIsRendered", function() { return imageIsRendered; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "off", function() { return off; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "on", function() { return on; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "onAnimationsComplete", function() { return onAnimationsComplete; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "parseCSSLength", function() { return parseCSSLength; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "prependChild", function() { return prependChild; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "replaceStyle", function() { return replaceStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "scrollIntoView", function() { return scrollIntoView; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "strToElement", function() { return strToElement; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "strToStyle", function() { return strToStyle; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "writeToIframe", function() { return writeToIframe; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "preparetagHTML", function() { return preparetagHTML; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "appendImpressionTags", function() { return appendImpressionTags; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }



var addOneTimeListener = function addOneTimeListener(el, eventName, fn) {
  var ignoreBubbling = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;

  var listener = function listener(event) {
    if (ignoreBubbling && event.target !== el) return;

    el.removeEventListener(eventName, listener);
    fn(event);
  };
  el.addEventListener(eventName, listener);
};

/** Responds to the first event triggered. Useful for polyfilling webkit prefixed events. */
var eventRacePromise = function eventRacePromise(el, events) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      timeout = _ref.timeout,
      _ref$matchTarget = _ref.matchTarget,
      matchTarget = _ref$matchTarget === undefined ? false : _ref$matchTarget;

  var eventsString = [].concat(events).join(" ");
  return new Promise(function (resolve) {
    var callbackRun = false;
    var callback = function callback() {
      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      if (callbackRun || matchTarget && el !== args[0].target) return;
      callbackRun = true;
      resolve.apply(undefined, args);
      off(el, _defineProperty({}, eventsString, callback));
    };

    on(el, _defineProperty({}, eventsString, callback));
    if (timeout != null) {
      setTimeout(function () {
        return callback({ message: "Promise timed out." });
      }, timeout);
    }
  });
};

var animationEndPromise = function animationEndPromise(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return eventRacePromise(el, "animationend webkitAnimationEnd", options);
};

var transitionEndPromise = function transitionEndPromise(el) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  return eventRacePromise(el, "transitionend webkitTransitionEnd", options);
};

/**
 * Given:
 *   - `el` - a DOM node
 *   - `transitions` - an array where each element is either 1) a function, or 2) an object of style property
 *     names to values
 * this sequentially 1) runs the function and waits for the Promise returned by the function to resolve (if
 * the function returns a Promise) before moving onto the next step, or 2) applies the styles to `el` and
 * waits for a `transitionend` event before moving onto the next step. Returns a Promise. `timeoutMS` is
 * an optional duration (in ms) after which the next transition should be run even if the previous transition
 * has not completed or if the previous function's returned promise has not resolved.
 */
var runTransitionSequence = function runTransitionSequence(el, transitions) {
  var _ref2 = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
      _ref2$timeoutMS = _ref2.timeoutMS,
      timeoutMS = _ref2$timeoutMS === undefined ? null : _ref2$timeoutMS,
      _ref2$continueFn = _ref2.continueFn,
      continueFn = _ref2$continueFn === undefined ? function () {
    return true;
  } : _ref2$continueFn;

  return transitions.reduce(function (prevTransitionEndPromise, thisTransition) {
    return prevTransitionEndPromise.finally(function () {
      if (!continueFn()) {
        return Promise.resolve();
      }

      var currentTransitionEndPromise = void 0;
      if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["isFunction"])(thisTransition)) {
        currentTransitionEndPromise = thisTransition();
      } else {
        currentTransitionEndPromise = transitionEndPromise(el);
        Object.assign(el.style, thisTransition);
      }

      if (timeoutMS == null) {
        return currentTransitionEndPromise;
      }

      return Promise.race([Object(__WEBPACK_IMPORTED_MODULE_0__utils__["timeout"])(timeoutMS), currentTransitionEndPromise]);
    });
  }, Promise.resolve());
};

var appendChildren = function appendChildren(node, children) {
  var fragment = document.createDocumentFragment();

  children.forEach(function (child) {
    if (!child) return;

    fragment.appendChild(child instanceof Node ? child : createElement(child));
  });

  node.appendChild(fragment);
};

var copyToClipboard = function copyToClipboard(text, multiline) {
  var elemType = multiline ? "textarea" : "input";
  var el = document.createElement(elemType);
  document.body.appendChild(el);
  el.value = text;
  el.select();
  document.execCommand("copy");
  el.remove();
};

/**
 * @param {Object} elementConfig A map of options specifying a new Element.
 * @param {String} [elementConfig.namespace = null] A namespace URI to associate with the new element.
 * See https://developer.mozilla.org/en-US/docs/Web/API/Document/createElementNS for details.
 * @param {String} [elementConfig.tagName = "div"] The tag name determining the result
 * Element's type. Defaults to "div".
 * @param {String[]} [elementConfig.classList = []] A list of classes. Falsy values
 * are ignored. Defaults to [].
 * @param {{}} [elementConfig.style = {}] A map of style settings to merge into the result
 * Element's style. Defaults to {}.
 * @param {{}} [elementConfig.attributes = {}] A map of attributes to set on the result
 * Element. Defaults to {}.
 * @param {{}} [elementConfig.data = {}] A map of data to merge into the result Element's
 * dataset. Defaults to {}.
 * @param {({}|Element)[]} [elementConfig.children = []] An array of Elements or
 * elementConfigs to append as children. Falsy values are ignored. Defaults to [].
 * @param {{}} [elementConfig.eventHandlers = {}] A map from event names to handlers,
 * which will all be assigned to listen on the result Element. Defaults to {}.
 * @returns {HTMLElement} An Element object with properties corresponding to the parameters.
 */
var createElement = function createElement(elementConfig) {
  if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["type"])(elementConfig) === "string" || Object(__WEBPACK_IMPORTED_MODULE_0__utils__["type"])(elementConfig) === "number") {
    return document.createTextNode(elementConfig);
  }

  var _elementConfig$namesp = elementConfig.namespace,
      namespace = _elementConfig$namesp === undefined ? null : _elementConfig$namesp,
      _elementConfig$tagNam = elementConfig.tagName,
      tagName = _elementConfig$tagNam === undefined ? "div" : _elementConfig$tagNam,
      _elementConfig$classL = elementConfig.classList,
      classList = _elementConfig$classL === undefined ? [] : _elementConfig$classL,
      _elementConfig$style = elementConfig.style,
      style = _elementConfig$style === undefined ? {} : _elementConfig$style,
      _elementConfig$attrib = elementConfig.attributes,
      attributes = _elementConfig$attrib === undefined ? {} : _elementConfig$attrib,
      _elementConfig$data = elementConfig.data,
      data = _elementConfig$data === undefined ? {} : _elementConfig$data,
      _elementConfig$childr = elementConfig.children,
      children = _elementConfig$childr === undefined ? [] : _elementConfig$childr,
      _elementConfig$eventH = elementConfig.eventHandlers,
      eventHandlers = _elementConfig$eventH === undefined ? {} : _elementConfig$eventH,
      unintendedProps = _objectWithoutProperties(elementConfig, ["namespace", "tagName", "classList", "style", "attributes", "data", "children", "eventHandlers"]);

  var unintendedKeys = Object.keys(unintendedProps);
  if (unintendedKeys.length > 0) {
    throw new Error("`createElement` must not receive unintended keys: " + JSON.stringify(unintendedKeys));
  }

  var element = namespace == null ? document.createElement(tagName) : document.createElementNS(namespace, tagName);
  var filteredClassList = (classList || []).filter(function (className) {
    return className;
  });
  if (filteredClassList.length > 0) {
    var _element$classList;

    (_element$classList = element.classList).add.apply(_element$classList, _toConsumableArray(filteredClassList));
  }
  Object.assign(element.style, style);

  Object.entries(attributes).forEach(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        name = _ref4[0],
        value = _ref4[1];

    element.setAttribute(name, value);
  });
  Object.assign(element.dataset, data);

  if (children.length > 0) {
    appendChildren(element, children);
  }

  on(element, eventHandlers);

  return element;
};


var empty = function empty(node) {
  while (node.firstChild) {
    node.removeChild(node.firstChild);
  }

  return node;
};

var fetchHTML = function fetchHTML(url) {
  return fetch(url).then(function (response) {
    return response.text();
  }).then(strToElement);
};

var firstAncestor = function firstAncestor(node, selector) {
  var halt = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "body";

  while (node != null && !node.matches(selector)) {
    if (node.matches(halt)) return null;

    node = node.parentNode;
  }

  return node;
};

/**
 * Returns a DocumentFragment containing the given HTML string, or null if
 * the string is empty or falsey.
 */
var fragmentFromString = function fragmentFromString(strHTML) {
  if (!strHTML) {
    return null;
  }

  var templateEl = document.createElement("template");
  templateEl.innerHTML = strHTML;
  return templateEl.content;
};

// Forces a reflow of the element so that cached styles are recomputed. This is
// important for ensuring that animations are used when changing styles or CSS
// classes via JS. See http://stackoverflow.com/q/11131875.
var forceReflow = function forceReflow(el) {
  el.offsetHeight;
};

var generateSnippetMap = function generateSnippetMap(html) {
  var wrapper = document.createElement("div");
  wrapper.innerHTML = html;
  var snippets = [].concat(_toConsumableArray(wrapper.querySelectorAll("[data-snippet]"))).reduce(function (coll, node) {
    var name = node.dataset.snippet;
    coll[name] = node;
    node.removeAttribute("data-snippet");
    node.remove();

    return coll;
  }, {});

  return function (name) {
    if (snippets[name] == null) return;

    return snippets[name].cloneNode(true);
  };
};

var getCSSProperty = function getCSSProperty(node, property) {
  return window.getComputedStyle(node).getPropertyValue(property);
};

var getElementsByClass = function getElementsByClass(parent, classNames) {
  return classNames.reduce(function (elements, name) {
    elements[Object(__WEBPACK_IMPORTED_MODULE_0__utils__["camelCase"])(name)] = parent.querySelector("." + name);

    return elements;
  }, {});
};

// A version of `getBoundingClientRect` relative to a reference node instead
// of the window.
var getRelativeBoundingClientRect = function getRelativeBoundingClientRect(node) {
  var reference = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;

  if (reference == null) {
    reference = node.parentNode;
  }

  var rect = node.getBoundingClientRect();
  var refRect = reference.getBoundingClientRect();
  return {
    top: rect.top - refRect.top,
    bottom: rect.bottom - refRect.bottom,
    left: rect.left - refRect.left,
    right: rect.right - refRect.right,
    width: rect.width,
    height: rect.height
  };
};

// Determines a bounding rectangle that encompasses all given nodes.
var getAggregateBoundingClientRect = function getAggregateBoundingClientRect(nodes) {
  return [].concat(_toConsumableArray(nodes)).reduce(function (agg, node) {
    var rect = node.getBoundingClientRect();
    agg.top = Math.min(agg.top, rect.top);
    agg.bottom = Math.max(agg.bottom, rect.bottom);
    agg.left = Math.min(agg.left, rect.left);
    agg.right = Math.max(agg.right, rect.right);
    agg.width = Math.max(agg.width, rect.left - agg.left + rect.width);
    agg.height = Math.max(agg.height, rect.top - agg.top + rect.height);
    return agg;
  }, {
    top: Infinity,
    bottom: 0,
    left: Infinity,
    right: 0,
    width: 0,
    height: 0
  });
};

// Given an element, this will return an integer that is the maximum font size (in px) that allows all the
// text to fit without overflow.
var getFontSizeToFit = function getFontSizeToFit(el) {
  var maxFontSizePx = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 24;

  var startingFontSize = el.style.fontSize;
  var startingOverflow = el.style.overflow;
  el.style.overflow = "hidden";
  var high = maxFontSizePx + 1;
  var low = 0;
  el.style.fontSize = high + "px";
  while (low + 1 < high) {
    var mid = low + (high - low >> 1);
    el.style.fontSize = mid + "px";
    if (el.clientHeight < el.scrollHeight || el.clientWidth < el.scrollWidth) {
      high = mid;
    } else {
      low = mid;
    }
  }

  el.style.fontSize = startingFontSize;
  el.style.overflow = startingOverflow;
  return low;
};

/**
 * Attempt to calculate the `font-size` needed to have the text of `el` fit within the given number of lines.
 *
 * This is far from a perfect solution as there are several factors that determine line count not to mention
 * occasional ambiguity of what constitutes a "line" when there's `innerHTML` to contend with.
 *
 * @param {HTMLElement} el - Element with text to fit `maxLines`.
 * @param {number} maxLines - Max line count to calculate for.
 * @param {number} [precision] - The amount in px to incrementally adjust `font-size` by to determine changes.
 * @return {number} - In px.
 */
var getFontSizeToFitLines = function getFontSizeToFitLines(el, maxLines) {
  var precision = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0.5;

  /**
   * NOTE(oscar): The computed style of certain "older" properties should always be in px regardless of
   * applied style.
   * @see https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
   */
  var fontSize = parseFloat(getCSSProperty(el, "font-size"));

  var prevFontSizeStyle = el.style.fontSize;
  var prevHeight = el.style.height;
  var prevLineHeight = el.style.lineHeight;
  el.style.height = "unset";

  // NOTE(oscar): Ensures line-height is sensitive to changes in font-size.
  el.style.lineHeight = "10em";

  var computedFontSize = Object(__WEBPACK_IMPORTED_MODULE_0__utils__["binaryFind"])(Object(__WEBPACK_IMPORTED_MODULE_0__utils__["range"])(precision, fontSize, precision), function (value) {
    el.style.fontSize = value + precision + "px";
    var lineHeight = parseFloat(getCSSProperty(el, "line-height"));
    var paddingTop = parseFloat(getCSSProperty(el, "padding-top"));
    var paddingBottom = parseFloat(getCSSProperty(el, "padding-bottom"));
    var textHeight = el.getBoundingClientRect().height - paddingTop - paddingBottom;
    return textHeight > lineHeight * maxLines;
  }) || fontSize;

  el.style.height = prevHeight;
  el.style.fontSize = prevFontSizeStyle;
  el.style.lineHeight = prevLineHeight;
  return computedFontSize;
};

var indexOf = function indexOf(node) {
  return [].indexOf.call(node.parentNode.children, node);
};

// Returns a Promise that resolves when the passed Image is rendered (determined by polling for a non-zero
// clientWidth and clientHeight).
var imageIsRendered = function imageIsRendered(img) {
  var timeout = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 10000;

  var start = Date.now();
  return new Promise(function (resolve, reject) {
    var checkRendered = function checkRendered() {
      if (Date.now() - start >= timeout) {
        reject(new Error("Timeout loading image \"" + img.src + "\""));
      } else if (img.clientWidth === 0 || img.clientHeight === 0) {
        requestAnimationFrame(checkRendered);
      } else {
        resolve();
      }
    };

    requestAnimationFrame(checkRendered);
  });
};

var off = function off(node, events) {
  Object.keys(events).forEach(function (names) {
    var listener = events[names];

    names.trim().split(/\s+/).forEach(function (name) {
      node.removeEventListener(name, listener);
    });
  });
};

var on = function on(node, events) {
  Object.keys(events).forEach(function (names) {
    var listener = events[names];

    names.trim().split(/\s+/).forEach(function (name) {
      node.addEventListener(name, listener);
    });
  });
};

var onAnimationsComplete = function onAnimationsComplete(els, callback) {
  var animationsLeft = els.length;
  els.forEach(function (el) {
    addOneTimeListener(el, "webkitAnimationEnd", function () {
      animationsLeft -= 1;
      if (animationsLeft === 0) {
        callback();
      }
    });
  });
};

// Returns a map of { units, value } for a CSS length property.
// The length must be a string with "px" or "%" units or a value of 0.
var parseCSSLength = function parseCSSLength(length) {
  if (length === 0 || length === "0") return { value: 0, units: "px" };

  var match = /(.+)(px|%)/.exec(length);
  if (!match) return null;

  var _match = _slicedToArray(match, 3),
      _ = _match[0],
      value = _match[1],
      units = _match[2];

  if (value == null || units == null) return null;

  return { units: units, value: Number(value) };
};

var prependChild = function prependChild(parentNode, node) {
  parentNode.insertBefore(node, parentNode.children[0]);

  return parentNode;
};

var replaceStyle = function replaceStyle(element) {
  for (var _len2 = arguments.length, newStyles = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
    newStyles[_key2 - 1] = arguments[_key2];
  }

  element.removeAttribute("style");
  Object.assign.apply(Object, [element.style].concat(newStyles));
};

var scrollIntoView = function scrollIntoView(node) {
  var rect = node.getBoundingClientRect();
  var pRect = node.parentNode.getBoundingClientRect();
  var topDiff = rect.top - pRect.top;
  var botDiff = rect.bottom - pRect.bottom;

  if (topDiff < 0 && botDiff > 0) {
    node.parentNode.scrollTop += (topDiff + botDiff) / 2;
  } else if (topDiff < 0) {
    node.parentNode.scrollTop += topDiff;
  } else if (botDiff > 0) {
    node.parentNode.scrollTop += botDiff;
  }
};

var strToElement = function strToElement(str) {
  var div = document.createElement("div");
  div.innerHTML = str.replace(/\n\s*/g, "");

  return div.firstChild;
};

var strToStyle = function strToStyle(str) {
  var style = document.createElement("style");
  style.innerHTML = str;

  return style;
};

/** Writes `contentHTML` into `iframeEl`. */
var writeToIframe = function writeToIframe(iframeEl, contentHTML) {
  iframeEl.contentWindow.document.open();
  iframeEl.contentWindow.document.write(contentHTML);
  iframeEl.contentWindow.document.close();
};

var preparetagHTML = function preparetagHTML(tagHTML) {
  var wrapperEl = document.createElement("div");
  wrapperEl.innerHTML = tagHTML;

  // Script tags must be reattached in order to run.
  [].concat(_toConsumableArray(wrapperEl.querySelectorAll("script"))).forEach(function (originalScriptTag) {
    var replacementScriptTag = document.createElement("script");
    [].concat(_toConsumableArray(originalScriptTag.attributes)).forEach(function (_ref5) {
      var name = _ref5.nodeName,
          value = _ref5.nodeValue;

      replacementScriptTag.setAttribute(name, value);
    });
    replacementScriptTag.innerHTML = originalScriptTag.innerHTML;
    originalScriptTag.parentNode.replaceChild(replacementScriptTag, originalScriptTag);
  });

  return wrapperEl;
};

var appendImpressionTags = function appendImpressionTags(containerEl, impressionTags) {
  impressionTags.forEach(function (tagHTML) {
    var wrapper = preparetagHTML(tagHTML);
    containerEl.append(wrapper);
  });
};

/***/ }),

/***/ 10:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export isTestError */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Warning; });
/* unused harmony export tryParseStackInfo */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return normalizeError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return normalizeErrorEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return normalizePromiseRejectionEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return shouldIgnoreError; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__ = __webpack_require__(0);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }



// if process.env.NODE_ENV === "test"
var isTestError = function isTestError(error) {
  // NOTE(Austin): Annoyingly, assertion errors will loop back here in
  // tests, so we have to ignore these.
  return error != null && error.constructor.name === "AssertionError";
};
// #endif

var Warning = function (_Error) {
  _inherits(Warning, _Error);

  function Warning() {
    var _ref;

    _classCallCheck(this, Warning);

    for (var _len = arguments.length, params = Array(_len), _key = 0; _key < _len; _key++) {
      params[_key] = arguments[_key];
    }

    // Maintains proper stack trace for where our error was thrown (only available on V8)
    var _this = _possibleConstructorReturn(this, (_ref = Warning.__proto__ || Object.getPrototypeOf(Warning)).call.apply(_ref, [this].concat(params)));

    if (Error.captureStackTrace) {
      Error.captureStackTrace(_this, Warning);
    }
    _this.severity = "warning";
    return _this;
  }

  return Warning;
}(Error);

var tryConvertStringToNumber = function tryConvertStringToNumber(str) {
  if (str == null) {
    return 0;
  }

  var parsed = parseInt(str);
  if (Number.isNaN(parsed)) {
    return 0;
  }

  return parsed;
};

var tryParseStackInfo = function tryParseStackInfo(stack) {
  if (stack == null) {
    return null;
  }

  var match = String(stack).match(
  // NOTE(Austin): We include about:srcdoc for inner_env errors.
  /(\b(?:[^ ]*\.js.*?)|(?:about:srcdoc)):(\d+)?:?(\d+)?/);

  if (match == null) {
    return null;
  }

  // Line and column need to be integers. We have them in our adexp
  // protobuf this way, so if they aren't we'll get a malformed message.
  return {
    sourceURL: match[1],
    line: tryConvertStringToNumber(match[2]),
    column: tryConvertStringToNumber(match[3])
  };
};

/**
 * Converts an Error or string into a map like
 * { message, stack, sourceURL, line, column }
 */
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Error/Error
var normalizeError = function normalizeError(obj) {
  if (obj == null) {
    return null;
  }

  if (typeof obj === "string") {
    return {
      message: obj
    };
  }

  var errorProps = Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["selectKeys"])(obj, Object.getOwnPropertyNames(obj));

  return Object.assign({}, tryParseStackInfo(errorProps.stack), errorProps);
};

/**
 * Converts an ErrorEvent object to a map like:
 * { message, line, column, sourceURL }
 * plus any additional information the error object contains.
 */
var normalizeErrorEvent = function normalizeErrorEvent(_ref2) {
  var message = _ref2.message,
      filename = _ref2.filename,
      lineno = _ref2.lineno,
      colno = _ref2.colno,
      error = _ref2.error;

  try {
    // Possible keys in an ErrorEvent:
    // [stack, name, fileName, lineNumber, columnNumber]
    var errorProps = error != null ? Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["selectKeys"])(error, Object.getOwnPropertyNames(error)) : {};

    var errorObj = Object.assign({
      message: message,
      severity: error && error.severity ? error.severity : "error",
      line: lineno,
      column: colno,
      sourceURL: filename
    }, errorProps);

    if (error == null) {
      return errorObj;
    }

    var parsedInfo = tryParseStackInfo(error.stack);
    return Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["mergePropertiesWithDefaults"])(errorObj, parsedInfo);
  } catch (e) {
    console.error("Error in normalizeErrorEvent: " + e.stack);
    return null;
  }
};

/**
 * Converts an PromiseRejectionEvent object to a map like
 * { message, line, column, sourceURL }
 * plus any additional information the error object contains.
 */
var normalizePromiseRejectionEvent = function normalizePromiseRejectionEvent(_ref3) {
  var reason = _ref3.reason;

  try {
    var reasonIsError = reason instanceof Error;
    var reasonIsString = typeof reason === "string";

    var errorMessage = reasonIsString ? reason : reason.message;

    // Possible keys in object (* are non-standard):
    // [message, stack*, name, fileName*, lineNumber*, columnNumber*]
    var errorProps = reasonIsError ? Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["selectKeys"])(reason, Object.getOwnPropertyNames(reason)) : {};

    var errorObj = Object.assign({
      message: errorMessage
    }, errorProps);

    return Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["mergePropertiesWithDefaults"])(errorObj, tryParseStackInfo(reason.stack));
  } catch (e) {
    console.error("Error in normalizePromiseRejectionEvent: " + e.stack);
    return null;
  }
};

/**
 * Normalizes the error and returns true if the error should be ingored;
 * otherwise, returns false.
 */
var shouldIgnoreError = function shouldIgnoreError(errorObj) {
  // Report only errors with non-malformed sourceURL.
  if (errorObj == null || errorObj.sourceURL === "undefined") {
    return true;
  }

  // mraid.js from adverty.com is a buggy implemenation. SMAATO and PUBMATIC are
  // the exchanges using such version and we see strange errors from the most.
  // While we are working with them to get a good MRAID implementation we filter
  // the noisy error messages by checking where the mraid.js is from.
  var stackFilter = new RegExp("adverty\\.com/.*mraid\\.js");

  // We see these errors quite often, and they are not related to our code.
  var regexFilters = ["Cannot read properties of undefined \\(reading 'fireEvent'\\)", "Cannot read property 'fireEvent' of undefined", "showInterstitial", "al_onPoststitialDismiss", "AFMA_ReceiveMessage", "webviewDidAppear", "AFMA_updateActiveView is not a function", "al_onAdViewRendered", "mraidbridge", "MoatMAK", "$adgIOS", "googqscp", "inmobi", "Script error", "avidbridge"];
  var messageFilter = new RegExp(regexFilters.join("|"));
  var errorStr = errorObj.message || errorObj.toString();
  if (messageFilter.test(errorStr) || stackFilter.test(errorObj.stack)) {
    return true;
  }

  var normalized = Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_utils__["selectKeys"])(errorObj, ["message", "line", "column", "stack", "sourceURL"]);

  var nKeys = Object.keys(normalized).length;
  var onlyMessage = "message" in errorObj && nKeys === 1 && errorObj.message === "undefined is not a function";

  var onlyMessageStack = "stack" in errorObj && "message" in errorObj && nKeys === 2 && errorObj.stack === "" && errorObj.message === "undefined is not a function";

  var noSourceURL = errorObj.sourceURL == null && nKeys === 5;
  return onlyMessage || onlyMessageStack || noSourceURL;
};

/***/ }),

/***/ 11:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



var EventListener = function () {
  _createClass(EventListener, null, [{
    key: "pubsubify",
    value: function pubsubify(object) {
      var methods = Object.getOwnPropertyNames(EventListener.prototype).filter(function (name) {
        return name !== "constructor";
      });
      Object.assign(object, new EventListener());
      Object.assign(object, Object(__WEBPACK_IMPORTED_MODULE_0__utils__["selectKeys"])(EventListener.prototype, methods));
    }
  }]);

  function EventListener() {
    _classCallCheck(this, EventListener);

    this.events = {};
  }

  _createClass(EventListener, [{
    key: "on",
    value: function on(map, callback) {
      var _this = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["type"])(map) !== "object") {
        map = _defineProperty({}, map, callback);
      }

      Object.keys(map).forEach(function (name) {
        if (_this.events[name] == null) {
          _this.events[name] = [];
        }

        _this.events[name].push(map[name]);
      });
    }
  }, {
    key: "once",
    value: function once(name, callback) {
      var _this2 = this;

      var single = function single() {
        for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }

        _this2.off(name, single);
        callback.apply(null, args);
      };

      this.on(name, single);
    }
  }, {
    key: "off",
    value: function off(map, callback) {
      var _this3 = this;

      if (Object(__WEBPACK_IMPORTED_MODULE_0__utils__["type"])(map) !== "object") {
        map = _defineProperty({}, map, callback);
      }

      Object.keys(map).forEach(function (name) {
        if (_this3.events[name] == null) return;

        var callback = map[name];
        if (callback == null) return delete _this3.events[name];

        _this3.events[name] = _this3.events[name].filter(function (cb) {
          return cb !== callback;
        });
        if (_this3.events[name].length === 0) {
          delete _this3.events[name];
        }
      });
    }
  }, {
    key: "emit",
    value: function emit(name) {
      for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }

      if (this.events[name] == null) return;

      return Promise.all(this.events[name].map(function (cb) {
        return cb.apply(null, args);
      }));
    }
  }, {
    key: "relay",
    value: function relay(listener, onEvent) {
      var emitEvent = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : onEvent;

      this.on(onEvent, listener.emit.bind(listener, emitEvent));
    }
  }]);

  return EventListener;
}();

/* harmony default export */ __webpack_exports__["a"] = (EventListener);

/***/ }),

/***/ 12:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_event_listener__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__constants__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__logger__ = __webpack_require__(5);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__error_handling__ = __webpack_require__(10);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }







/**
 * This interval is the time between attempts to open a URL via different
 * methods (see `LiftoffMRAID.open`).
 */
var CLICK_RETRY_INTERVAL_MS = 1000;

// Most of exchanges have MRAID detected in code except the IronSource
// We do MRAID open regardless for IronSource according to their request.
var mraidOpenOnlyExchanges = new Set([__WEBPACK_IMPORTED_MODULE_2__constants__["w" /* EXCHANGE_A9TAM */], __WEBPACK_IMPORTED_MODULE_2__constants__["y" /* EXCHANGE_APPLOVIN */], __WEBPACK_IMPORTED_MODULE_2__constants__["B" /* EXCHANGE_INMOBI */], __WEBPACK_IMPORTED_MODULE_2__constants__["C" /* EXCHANGE_INNERACTIVE */], __WEBPACK_IMPORTED_MODULE_2__constants__["D" /* EXCHANGE_IRONSOURCE */], __WEBPACK_IMPORTED_MODULE_2__constants__["E" /* EXCHANGE_MINTEGRAL */], __WEBPACK_IMPORTED_MODULE_2__constants__["G" /* EXCHANGE_NIMBUS */], __WEBPACK_IMPORTED_MODULE_2__constants__["J" /* EXCHANGE_TOPON */], __WEBPACK_IMPORTED_MODULE_2__constants__["K" /* EXCHANGE_VERVE */], __WEBPACK_IMPORTED_MODULE_2__constants__["L" /* EXCHANGE_VUNGLE */]]);
// No MRAID is detected and confirmed no MRAID from exchanges
var anchorOpenExchanges = new Set([__WEBPACK_IMPORTED_MODULE_2__constants__["x" /* EXCHANGE_ADPOPCORN */], __WEBPACK_IMPORTED_MODULE_2__constants__["z" /* EXCHANGE_CONNATIX */], __WEBPACK_IMPORTED_MODULE_2__constants__["F" /* EXCHANGE_MOMENTO */], __WEBPACK_IMPORTED_MODULE_2__constants__["H" /* EXCHANGE_PANGLE */], __WEBPACK_IMPORTED_MODULE_2__constants__["I" /* EXCHANGE_SAMSUNG */]]);
// No MRAID is detected and exchanges have not confirmed they support MRAID.
// TODO(cwu): Xiaomi is still in contact. Will be handled after 2025-09-11 meeting.
var mraidOpenUncertainExchanges = new Set([__WEBPACK_IMPORTED_MODULE_2__constants__["M" /* EXCHANGE_XIAOMI */]]);

/**
 * This is a low-level wrapper around mraid that should be usable generally
 * (i.e. in any HTML ad environment). It's used by both madlib and third-party
 * creatives.
 */

var LiftoffMRAID = function () {
  function LiftoffMRAID() {
    _classCallCheck(this, LiftoffMRAID);
  }

  _createClass(LiftoffMRAID, null, [{
    key: "init",

    /**
     * Among other things, this function attaches event listeners to the
     * window.mraid object. It should be called as soon as possible after
     * window.mraid is defined. Because of this side-effect, it should also only
     * be called once.
     */
    value: function init() {
      this.liftoffMraidInitTimestamp = Date.now();

      __WEBPACK_IMPORTED_MODULE_0__frontendlib_event_listener__["a" /* default */].pubsubify(this);
      this.on = this.on.bind(this);
      this.once = this.once.bind(this);
      this._addMraidEventListener = this._addMraidEventListener.bind(this);

      this.viewableDurationMS = null;
      this.lastViewableTS = null;
      this.clickRetryTimeout = null;
      this.lastOpenedURL = null;
      this.isOrientationLocked = false;
      this.orientationToLock = null;
      this.viewable = null;
      this.isViewableByEvent = null;

      /** Keeps track of each version of window.mraid loaded. */
      this.mraids = [];
      /** This index of this.mraids that is currently loaded on window.mraid. */
      this.mraidIndex = null;

      /**
       * This object keeps track of what the current mraid object supports at the
       * moment support was checked.
       */
      this.supported = {
        methods: {},
        /**
         * NOTE(oscar): Unlike MRAID methods, we log mraid events that we listen
         * to as they occur.
         */
        events: {}
      };

      this._setInitialState();
      this._addEventListeners();
    }

    /** Returns time since LiftoffMRAID has been initialized in milliseconds. */

  }, {
    key: "sinceInit",
    value: function sinceInit() {
      return Date.now() - this.liftoffMraidInitTimestamp;
    }
  }, {
    key: "getSupportedLog",
    value: function getSupportedLog() {
      return Object.assign({
        "document.hidden": document.hidden,
        "document.visibilityState": document.visibilityState,
        "LiftoffMRAID.viewable": LiftoffMRAID.viewable,
        MRAID_ENV: window.MRAID_ENV
      }, this.supported);
    }
  }, {
    key: "_setInitialState",
    value: function _setInitialState() {
      var _this = this;

      var mraid = this.getMRAID();
      this.ready = this._mraidTry(function () {
        return _this.hasSupport("getState") && mraid.getState() === "default";
      }, { tag: "getState", fallback: false });

      this.isViewableByEvent = this.hasSupport("isViewable") ? this._mraidTry(function () {
        return mraid.isViewable();
      }, {
        tag: "isViewable",
        // NOTE(oscar): If isViewable() still fails, we fall back to
        // document.visibilityState.
        fallback: document.visibilityState !== "hidden"
      }) : document.visibilityState !== "hidden";
      this.processViewableChange(this.isViewableByEvent && this.isViewportShown());
      this.viewableDurationMS = 0;
    }

    /** TODO(oscar): Don't append to log if it won't be sent to Adexp. */

  }, {
    key: "_appendEventLog",
    value: function _appendEventLog(eventName, mraidIndex, args) {
      if (this.supported.events[eventName] == null) {
        this.supported.events[eventName] = [];
      }
      this.supported.events[eventName].push({
        sinceInitMs: this.sinceInit(),
        args: args,
        mraidIndex: mraidIndex,
        version: this.getMRAIDVersion()
      });
    }

    /**
     * This function is used to wrap calls to mraid methods in a try/catch block.
     * Any error gets logged in this.supported.errors.
     *
     * In general, this.hasSupport() is used to check for support. This function
     * serves as a further safeguard against errors due to faulty mraid
     * implementations.
     */

  }, {
    key: "_mraidTry",
    value: function _mraidTry(func, _ref) {
      var _ref$tag = _ref.tag,
          tag = _ref$tag === undefined ? "other" : _ref$tag,
          _ref$fallback = _ref.fallback,
          fallback = _ref$fallback === undefined ? undefined : _ref$fallback,
          _ref$logError = _ref.logError,
          logError = _ref$logError === undefined ? true : _ref$logError;

      try {
        return func();
      } catch (e) {
        if (logError) {
          // Record the error.
          this.supported.errors = this.supported.errors || [];
          var version = void 0;
          try {
            version = this.getMRAID().getVersion();
          } catch (ee) {
            console.error("Failed to get MRAID version", ee);
          }
          this.supported.errors.push({
            tag: tag,
            sinceInitMs: this.sinceInit(),
            message: e != null ? e.message : null,
            mraidIndex: this.mraidIndex,
            version: version
          });
        }
        return fallback;
      }
    }
  }, {
    key: "_addMraidEventListener",
    value: function _addMraidEventListener(eventName, callback) {
      var _this2 = this;

      if (!this.hasSupport("addEventListener")) return;

      var mraid = this.getMRAID();
      var mraidIndex = this.mraidIndex;

      this._mraidTry(function () {
        mraid.addEventListener(eventName, function () {
          for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
            args[_key] = arguments[_key];
          }

          _this2._appendEventLog(eventName, mraidIndex, args);

          callback.apply(undefined, args);
        });
      }, { tag: eventName });
    }
  }, {
    key: "_addEventListeners",
    value: function _addEventListeners() {
      var _this3 = this;

      // "error" events include 2 arguments: a message and an action. The action
      // is the MRAID API call that caused the error.
      this._addMraidEventListener("error", function () {
        for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        var e = new Error("MRAID error: " + args);
        _this3.emit("error", e);
      });
      this._addMraidEventListener("ready", function () {
        if (_this3.ready) return;
        _this3.ready = true;
        _this3.emit("ready");
      });
      this._addMraidEventListener("viewableChange", function (viewable) {
        _this3.isViewableByEvent = viewable;
        _this3.processViewableChange(_this3.isViewableByEvent && _this3.isViewportShown());
      });

      // NOTE(oscar): We're using _addMraidEventListener to log this event.
      this._addMraidEventListener("exposureChange", function () {});

      /**
       * The following is a fallback in case mraid's viewableChange is not
       * supported.
       */
      document.addEventListener("visibilitychange", function () {
        for (var _len3 = arguments.length, args = Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        _this3._appendEventLog("document.visibilitychange", _this3.mraidIndex, args);

        /**
         * We delay the following by an event cycle to allow mraid's
         * viewableChange event to occur first.
         */
        Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["runAsync"])(function () {
          if (_this3.supported.events.viewableChange == null) {
            _this3.isViewableByEvent = document.visibilityState !== "hidden";
            _this3.processViewableChange(_this3.isViewableByEvent && _this3.isViewportShown());
          }
        });
      });
    }
  }, {
    key: "processViewableChange",
    value: function processViewableChange(isViewable) {
      /**
       * NOTE(oscar): On the off chance the mraid implementation gives us
       * truthy/falsey values instead.
       */
      var normalizedIsViewable = !!isViewable;
      if (normalizedIsViewable === this.viewable) return;
      this.viewable = normalizedIsViewable;

      if (this.viewable) {
        this.lastViewableTS = Date.now();
        if (!this.isOrientationLocked && this.orientationToLock != null) {
          // NOTE(oscar): We won't lock the orientation until after the ad is
          // viewable.
          this.lockOrientation(this.orientationToLock);
        }
      } else {
        this.viewableDurationMS += this.lastViewableTS == null ? 0 : Date.now() - this.lastViewableTS;
        this.lastOpenedURL = null;
        clearTimeout(this.clickRetryTimeout);
      }

      if (this.viewable) {
        this.emit("viewable");
      }
      this.emit("viewableChange", this.viewable);
    }
  }, {
    key: "onReady",
    value: function onReady(fn) {
      if (this.ready) {
        Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["runAsync"])(fn);
        return;
      }
      this.once("ready", fn);
    }

    /**
     * Adds a listener to the "viewable" event. The "viewable" event fires
     * whenever we believe the ad has become visible to the user. If the ad was
     * already visible, then it fires the listener immediately.
     * @param {Function} callback
     * @param {boolean} continuous – Whether to listen to all viewable events.
     * Defaults to false, meaning it will only trigger the callback once.
     * @returns
     */

  }, {
    key: "onViewable",
    value: function onViewable(callback) {
      var continuous = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      if (this.viewable) {
        Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["runAsync"])(callback);
        if (!continuous) return;
      }
      var deferrer = continuous ? this.on : this.once;
      deferrer("viewable", callback);
    }

    /** Runs fn now with current viewable value and on "viewableChange" event. */

  }, {
    key: "nowAndOnViewableChange",
    value: function nowAndOnViewableChange(fn) {
      var _this4 = this;

      Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["runAsync"])(function () {
        return fn(_this4.viewable);
      });

      this.on("viewableChange", fn);
    }

    // TODO(oscar): Replace with nowAndOnViewableChange once v2 productionizes.

  }, {
    key: "onViewableChange",
    value: function onViewableChange(fn) {
      this.nowAndOnViewableChange(fn);
    }

    // IMPORTANT: This method MUST be called synchronously with a user action.

  }, {
    key: "open",
    value: function open(url, _ref2) {
      var _this5 = this;

      var exchange = _ref2.exchange,
          platform = _ref2.platform,
          _ref2$abTests = _ref2.abTests,
          abTests = _ref2$abTests === undefined ? [] : _ref2$abTests,
          _ref2$isLiftoffURL = _ref2.isLiftoffURL,
          isLiftoffURL = _ref2$isLiftoffURL === undefined ? false : _ref2$isLiftoffURL,
          _ref2$isAutoclick = _ref2.isAutoclick,
          isAutoclick = _ref2$isAutoclick === undefined ? false : _ref2$isAutoclick;

      // To prevent the click waterfall from resetting if the user clicks twice in
      // rapid succession, don't restart the waterfall unless the URL being opened
      // is different.
      if (this.lastOpenedURL === url) return;

      this.lastOpenedURL = url;
      clearTimeout(this.clickRetryTimeout);

      var mraidOpenIsSupported = this.hasSupport("open");
      var isMRAIDOnlyExchange = mraidOpenOnlyExchanges.has(exchange);
      var isAnchorOpenExchange = anchorOpenExchanges.has(exchange);
      var requireMRAID = mraidOpenIsSupported && (isAutoclick || isMRAIDOnlyExchange);

      var getFinalClickURL = function getFinalClickURL(openMethod) {
        return isLiftoffURL ? Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["appendParamObjectToURL"])(url, {
          open_method: openMethod,
          tracking_method: __WEBPACK_IMPORTED_MODULE_2__constants__["T" /* TRACKING_METHOD_OPEN_METHOD */]
        }) : url;
      };
      var mraidOpen = function mraidOpen(url) {
        if (!_this5.ready) {
          _this5.emit("error", new Error("Called mraid.open before mraid was ready"));
        }
        _this5.getMRAID().open(url);
      };
      var anchorOpen = function anchorOpen(url) {
        var a = document.createElement("a");
        a.href = url;
        a.target = "_blank";
        a.click();
      };
      var locationOpen = function locationOpen(url) {
        window.location = url;
      };

      // To ensure that the user can click through, attempt multiple methods of
      // navigating to the URL. In order, they are:
      // 1. `mraid.open`, if mraid is available
      // 2. A fake anchor element
      // 3. `window.location`
      var openMethods = [{
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* CLICK_OPEN_METHOD_MRAID */],
        enabled: mraidOpenIsSupported,
        fn: mraidOpen
      }, {
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["r" /* CLICK_OPEN_METHOD_ANCHOR */],
        enabled: !requireMRAID,
        fn: anchorOpen
      }, {
        type: __WEBPACK_IMPORTED_MODULE_2__constants__["s" /* CLICK_OPEN_METHOD_LOCATION */],
        enabled: !requireMRAID,
        fn: locationOpen
      }].filter(function (_ref3) {
        var enabled = _ref3.enabled;
        return enabled;
      });

      /**
       * Checks if we expect for the SKProductView will open. If so, then it's
       * likely for no visibility event to occur.
       * TODO(oscar/cwu): Replace url check with other `skproductview` indicating
       * boolean that should be populated from h2go.
       */
      var isOpenSKProductView = function isOpenSKProductView(openMethod, url) {
        var appleStoreUrlPrefix = new RegExp("^(https?://)?apps\\.apple\\.com");
        return openMethod.type === __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* CLICK_OPEN_METHOD_MRAID */] && appleStoreUrlPrefix.test(url);
      };

      var tryOpen = function tryOpen() {
        var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;

        // We don't emit any error if we're in the waterfall experiment
        // because this is guaranteed to happen if the user clicks more than
        // once (whereas in the original this will only happen if it thinks a
        // click failed).
        if (index > 0) {
          var methodType = openMethods[index - 1].type;
          _this5.emit("error", new __WEBPACK_IMPORTED_MODULE_4__error_handling__["a" /* Warning */]("Failed to open " + url + " using " + methodType));
        }
        if (index === openMethods.length - 1) {
          _this5.lastOpenedURL = null;
        }
        if (index >= openMethods.length && !(index === 1 && isOpenSKProductView(openMethods[0], url))) {
          _this5.emit("error", new Error("Failed to open " + url + " by any methods. Tried " + openMethods.length + " method(s)"));
          return;
        }

        var openMethod = openMethods[index];
        var finalClickURL = getFinalClickURL(openMethod.type);
        openMethod.fn(finalClickURL);
        _this5.emit("clickMethodTried", {
          clickOpenMethod: openMethod.type,
          isAutoclick: isAutoclick
        });
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].recordMetricV2("click_url_open", {
          method: openMethod.type,
          index: index,
          total: openMethods.length,
          is_mraid_ready: _this5.ready
        });

        _this5.clickRetryTimeout = setTimeout(tryOpen.bind(_this5, index + 1), CLICK_RETRY_INTERVAL_MS);
      };

      if (isMRAIDOnlyExchange) {
        mraidOpen(getFinalClickURL(__WEBPACK_IMPORTED_MODULE_2__constants__["t" /* CLICK_OPEN_METHOD_MRAID */]));
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].recordMetricV2("click_url_open", {
          method: __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* CLICK_OPEN_METHOD_MRAID */],
          index: 0,
          total: 1,
          is_mraid_ready: this.ready
        });
      } else if (isAnchorOpenExchange) {
        anchorOpen(getFinalClickURL(__WEBPACK_IMPORTED_MODULE_2__constants__["r" /* CLICK_OPEN_METHOD_ANCHOR */]));
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].recordMetricV2("click_url_open", {
          method: __WEBPACK_IMPORTED_MODULE_2__constants__["r" /* CLICK_OPEN_METHOD_ANCHOR */],
          index: 0,
          total: 1,
          is_mraid_ready: this.ready
        });
      } else if (mraidOpenUncertainExchanges.has(exchange)) {
        // Keep these exchanges still in the click waterfall for now.
        tryOpen();
      } else if (abTests.includes("click-waterfall-removal-experiment")) {
        mraidOpen(getFinalClickURL(__WEBPACK_IMPORTED_MODULE_2__constants__["t" /* CLICK_OPEN_METHOD_MRAID */]));
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].recordMetricV2("click_url_open", {
          method: __WEBPACK_IMPORTED_MODULE_2__constants__["t" /* CLICK_OPEN_METHOD_MRAID */],
          index: 0,
          total: 1,
          is_mraid_ready: this.ready
        });
      } else {
        tryOpen();
      }
    }
  }, {
    key: "close",
    value: function close() {
      var _this6 = this;

      this.onReady(function () {
        __WEBPACK_IMPORTED_MODULE_3__logger__["a" /* default */].recordMetricV2("close_count", 1);

        if (!_this6.hasSupport("close")) {
          _this6.emit("error", new __WEBPACK_IMPORTED_MODULE_4__error_handling__["a" /* Warning */]("Attempted to call 'MRAID.close' when it is not supported."));
          return;
        }

        _this6.getMRAID().close();
      });
    }

    // NOTE(brian): The `useCustomClose` method is deprecated (read: ignored) in
    // MRAID 3.0.
    // NOTE(Casey): Unity's `useCustomClose` throws an error. Although we handle
    // this case by not trying custom custom close on Unity, this implementation
    // handles that scenario in case other exchanges are (unknowingly) similar.
    /**
     * Returns a `Promise` that resolves with `false` if custom close was not set
     * or to `true` if custom close was set successfully. The `Promise` rejects
     * if an error was thrown.
     */

  }, {
    key: "useCustomClose",
    value: function useCustomClose(use) {
      var _this7 = this;

      return new Promise(function (resolve, reject) {
        try {
          _this7.onReady(function () {
            if (!(_this7.hasSupport("useCustomClose") && _this7.hasSupport("close") && use)) {
              return resolve(false);
            }
            var mraid = _this7.getMRAID();
            mraid.useCustomClose(use);
            resolve(use);
          });
        } catch (e) {
          reject(e);
        }
      });
    }
  }, {
    key: "getViewableDurationMS",
    value: function getViewableDurationMS() {
      if (!this.viewable) return this.viewableDurationMS;
      if (this.lastViewableTS == null) {
        console.error("Internal LiftoffMRAID error: this.lastViewableTS should be set.");
        return this.viewableDurationMS;
      }
      return this.viewableDurationMS + (Date.now() - this.lastViewableTS);
    }
  }, {
    key: "lockOrientation",
    value: function lockOrientation(orientation) {
      if (!this.ready || !this.viewable || !this.hasSupport("setOrientationProperties")) {
        return;
      }

      this.orientationToLock = orientation;
      var mraid = this.getMRAID();
      this._mraidTry(function () {
        mraid.setOrientationProperties({
          allowOrientationChange: false,
          forceOrientation: orientation
        });
      }, { tag: "setOrientationProperties" });
      this.isOrientationLocked = true;
    }
  }, {
    key: "getMRAID",
    value: function getMRAID() {
      var windowMraid = window.mraid;
      if (windowMraid != null) {
        // NOTE(oscar): There are some sdks that will delete window.mraid after it
        // was initialized. In some cases at least, this is done to replace the
        // mraid object with a new one, but it's unclear why this is done in an
        // asynchronous way. In order not to race with the SDK's implementation of
        // MRAID, we will use the last mraid object loaded as a fallback.
        // Related test: https://docs.google.com/document/d/1TWLnTFlTGFc6ZJB_UXfR8QvmEa8x_d3k532fmX-13Fs
        // Related test 2: https://docs.google.com/document/d/1iChTG_zLZvQzI5Opw-6kpHqRCXRYklTPpbNB7TPBFdQ
        this.mraidIndex = this.mraids.indexOf(windowMraid);
        if (this.mraidIndex === -1) {
          this.mraidIndex = this.mraids.length;
          this.mraids.push(windowMraid);
        }
      }

      return this.mraids[this.mraidIndex];
    }
  }, {
    key: "logMethodSupport",
    value: function logMethodSupport(methodName, isSupported) {
      if (this.supported.methods[methodName] == null) {
        this.supported.methods[methodName] = {};
      }
      if (this.supported.methods[methodName][this.mraidIndex] == null) {
        this.supported.methods[methodName][this.mraidIndex] = [];
      }
      // NOTE(oscar): The MRAID spec allows for a method to go from no support to
      // support when the mraid's "ready" event triggers.
      this.supported.methods[methodName][this.mraidIndex].push({
        sinceInitMs: this.sinceInit(),
        ready: this.ready,
        support: isSupported,
        /** Logging is disabled here to prevent an infinite loop. */
        version: this.getMRAIDVersion({ log: false })
      });
    }

    /**
     * Checks to see if the MRAID implementation supports the given method.
     * More specifically, this checks to see if the method is a function on the
     * window.mraid object. It does not actually call the method to see if it
     * works and any caller should be prepared to handle errors.
     *
     * @param {string} prop - The name of the method to check.
     * @param {Object} options
     * @param {boolean} options.log - Whether to log the result of the check.
     */

  }, {
    key: "hasSupport",
    value: function hasSupport(prop) {
      var _ref4 = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {},
          _ref4$log = _ref4.log,
          log = _ref4$log === undefined ? true : _ref4$log;

      var mraid = this.getMRAID();
      if (mraid == null) {
        return false;
      }

      if (prop === "mraid") {
        return true;
      }

      var support = Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["type"])(mraid[prop]) === "function";

      if (log) {
        this.logMethodSupport(prop, support);
      }

      return support;
    }

    /** Returns the currently loaded MRAID version. */

  }, {
    key: "getMRAIDVersion",
    value: function getMRAIDVersion() {
      var _this8 = this;

      var _ref5 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref5$log = _ref5.log,
          log = _ref5$log === undefined ? true : _ref5$log;

      return this._mraidTry(function () {
        return _this8.hasSupport("getVersion", { log: log }) ? _this8.getMRAID().getVersion() : null;
      }, { tag: "getVersion", logError: log });
    }
  }, {
    key: "isViewportShown",
    value: function isViewportShown() {
      return window.innerHeight > 0 && window.innerWidth > 0;
    }
  }]);

  return LiftoffMRAID;
}();

if (window._LiftoffMRAID == null) {
  LiftoffMRAID.init();
  /**
   * NOTE(oscar): Global state is needed in order to only call .init() once and
   * to ensure that the same LiftoffMRAID is exported.
   */
  window._LiftoffMRAID = LiftoffMRAID;
}

/* harmony default export */ __webpack_exports__["a"] = (window._LiftoffMRAID);

/***/ }),

/***/ 13:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AdexpMetricV2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AdexpJavaScriptError; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AdexpLog; });
/* unused harmony export AdexpContext */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AdexpMessage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return getAdexpContextSnapshotFn; });
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Wrappers around adexp objects contained in adexpjson.go

var AdexpMetricV2 = function AdexpMetricV2(name, value) {
  _classCallCheck(this, AdexpMetricV2);

  this.name = name;
  this.value = value;
};

var AdexpJavaScriptError = function AdexpJavaScriptError() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      message = _ref.message,
      _ref$severity = _ref.severity,
      severity = _ref$severity === undefined ? "error" : _ref$severity,
      sourceURL = _ref.sourceURL,
      line = _ref.line,
      column = _ref.column,
      stack = _ref.stack;

  _classCallCheck(this, AdexpJavaScriptError);

  this.error = {
    message: message,
    severity: severity,
    sourceURL: sourceURL,
    line: line,
    column: column,
    stack: stack
  };
};

var AdexpLog = function AdexpLog(tag, message, data) {
  _classCallCheck(this, AdexpLog);

  this.tag = tag;
  this.message = message;
  Object.assign(this, data);
};

var AdexpContext = function AdexpContext() {
  var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      viewportWidth = _ref2.viewportWidth,
      viewportHeight = _ref2.viewportHeight,
      adLanguage = _ref2.adLanguage,
      mraid = _ref2.mraid;

  _classCallCheck(this, AdexpContext);

  this.ad_language = adLanguage;
  this.mraid = mraid;
  this.viewport_height = viewportHeight;
  this.viewport_width = viewportWidth;
};

var AdexpMessage = function AdexpMessage() {
  var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      context = _ref3.context,
      metric = _ref3.metric,
      log = _ref3.log;

  _classCallCheck(this, AdexpMessage);

  Object.assign(this, context);
  // NOTE(Austin): metrics_v2 must be an array. For now
  // we don't log more than one metric at a time though.
  this.metrics_v2 = metric != null ? [metric] : undefined;
  this.log = log;
};

// TODO(Austin): Consolidate ClickMetric here.

/**
 * Returns a function that takes a snapshot of the current environment
 * and returns a `AdexpContext`.
 */
var getAdexpContextSnapshotFn = function getAdexpContextSnapshotFn(viewportEl, hasMraidFn) {
  return function () {
    var _ref4 = viewportEl != null ? viewportEl.getBoundingClientRect() : {},
        width = _ref4.width,
        height = _ref4.height;

    return new AdexpContext({
      viewportWidth: width != null ? Math.round(width) : undefined,
      viewportHeight: height != null ? Math.round(height) : undefined,
      adLanguage: navigator.language,
      mraid: hasMraidFn()
    });
  };
};

/***/ }),

/***/ 2:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "P", function() { return PLATFORM_ANDROID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "Q", function() { return PLATFORM_IOS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return AUDIO_POLICY_ALWAYS_MUTE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return AUDIO_POLICY_ON_INTERACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return AUDIO_POLICY_NO_RESTRICTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "w", function() { return EXCHANGE_A9TAM; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "x", function() { return EXCHANGE_ADPOPCORN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "y", function() { return EXCHANGE_APPLOVIN; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "z", function() { return EXCHANGE_CONNATIX; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "A", function() { return EXCHANGE_DOUBLECLICK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "B", function() { return EXCHANGE_INMOBI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "C", function() { return EXCHANGE_INNERACTIVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "D", function() { return EXCHANGE_IRONSOURCE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "E", function() { return EXCHANGE_MINTEGRAL; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "F", function() { return EXCHANGE_MOMENTO; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "G", function() { return EXCHANGE_NIMBUS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "H", function() { return EXCHANGE_PANGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "I", function() { return EXCHANGE_SAMSUNG; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "J", function() { return EXCHANGE_TOPON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "K", function() { return EXCHANGE_VERVE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "L", function() { return EXCHANGE_VUNGLE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "M", function() { return EXCHANGE_XIAOMI; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "O", function() { return ORIENTATION_PORTRAIT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "N", function() { return ORIENTATION_LANDSCAPE; });
/* unused harmony export CONNECTION_TYPE_WIFI */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return CLICK_AREA_TYPE_OTHER; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return CLICK_AREA_TYPE_CTA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return CLICK_METRIC_TYPE_CLOSE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return CLICK_METRIC_TYPE_CTA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return CLICK_METRIC_TYPE_DEADZONE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return CLICK_METRIC_TYPE_UNKNOWN; });
/* unused harmony export CLICK_REJECTION_REASON_UNKNOWN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "u", function() { return CLICK_REJECTION_REASON_NO_INTERACTIONS; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return CLICKTHROUGH_URL_TYPE_LIFTOFF_ENDPOINT; });
/* unused harmony export CLICKTHROUGH_URL_TYPE_APP_STORE */
/* unused harmony export CLICK_TRACKING_URL_TYPE_UNKNOWN */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "v", function() { return CLICK_TRACKING_URL_TYPE_LIFTOFF_ENDPOINT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "T", function() { return TRACKING_METHOD_OPEN_METHOD; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "S", function() { return TRACKING_METHOD_IMAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "R", function() { return TRACKING_METHOD_BEACON; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return AUTOCLICK_TYPE_LAST_INTERACTION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return AUTOCLICK_TYPE_INTERACTION_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return AUTOCLICK_TYPE_LAST_INTERACTION_AND_INTERACTION_COUNT; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return AUTOCLICK_TYPE_COMPLETED_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return AUTOCLICK_TYPE_LOAD_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return AUTOCLICK_TYPE_VIEWABLE_DELAY; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return AUTOCLICK_TYPE_VIEWABLE_DELAY_WITH_RESET; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "t", function() { return CLICK_OPEN_METHOD_MRAID; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "r", function() { return CLICK_OPEN_METHOD_ANCHOR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "s", function() { return CLICK_OPEN_METHOD_LOCATION; });
var PLATFORM_ANDROID = "android";
var PLATFORM_IOS = "ios";

var AUDIO_POLICY_ALWAYS_MUTE = "always-mute";
var AUDIO_POLICY_ON_INTERACTION = "on-interaction";
var AUDIO_POLICY_NO_RESTRICTIONS = "no-restrictions";

// TODO(Casey): Use constants instead of string literals for all exchanges
// throughout.
var EXCHANGE_A9TAM = "a9tam";
var EXCHANGE_ADPOPCORN = "adpopcorn";
var EXCHANGE_APPLOVIN = "applovin";
var EXCHANGE_CONNATIX = "connatix";
var EXCHANGE_DOUBLECLICK = "doubleclick";
var EXCHANGE_INMOBI = "inmobi";
var EXCHANGE_INNERACTIVE = "inneractive-direct";
var EXCHANGE_IRONSOURCE = "ironsource";
var EXCHANGE_MINTEGRAL = "mintegral";
var EXCHANGE_MOMENTO = "momento";
var EXCHANGE_NIMBUS = "nimbus";
var EXCHANGE_PANGLE = "pangle";
var EXCHANGE_SAMSUNG = "samsung";
var EXCHANGE_TOPON = "topon";
var EXCHANGE_VERVE = "verve";
var EXCHANGE_VUNGLE = "vungle";
var EXCHANGE_XIAOMI = "xiaomi";

var ORIENTATION_PORTRAIT = "portrait";
var ORIENTATION_LANDSCAPE = "landscape";

// These must correspond to the rtb.proto ConnectionType enum definition.
var CONNECTION_TYPE_WIFI = 2;

// These must correspond to the rtb.proto ClickAreaType enum definition.
var CLICK_AREA_TYPE_OTHER = 1;
var CLICK_AREA_TYPE_CTA = 3;

var CLICK_METRIC_TYPE_CLOSE = "CLOSE";
var CLICK_METRIC_TYPE_CTA = "CTA";
var CLICK_METRIC_TYPE_DEADZONE = "DEADZONE";
var CLICK_METRIC_TYPE_UNKNOWN = "UNKNOWN_CLICK_TYPE";

// This must correspond to the rtb.proto ClickRejectionReason enum definition.
var CLICK_REJECTION_REASON_UNKNOWN = 0;
var CLICK_REJECTION_REASON_NO_INTERACTIONS = 1;

// This must correspond to the auction.proto ClickthroughURLType.
var CLICKTHROUGH_URL_TYPE_LIFTOFF_ENDPOINT = 1;
var CLICKTHROUGH_URL_TYPE_APP_STORE = 2;

// This must correspond to the auction.proto ClickTrackingURLType.
var CLICK_TRACKING_URL_TYPE_UNKNOWN = 0;
var CLICK_TRACKING_URL_TYPE_LIFTOFF_ENDPOINT = 1;

// This must correspond to the rtb.proto TrackingMethod enum definition.
var TRACKING_METHOD_OPEN_METHOD = 1;
var TRACKING_METHOD_IMAGE = 2;
var TRACKING_METHOD_BEACON = 3;

var AUTOCLICK_TYPE_LAST_INTERACTION = "lastInteraction";
var AUTOCLICK_TYPE_INTERACTION_COUNT = "interactionCount";
var AUTOCLICK_TYPE_LAST_INTERACTION_AND_INTERACTION_COUNT = "lastInteractionAndInteractionCount";
var AUTOCLICK_TYPE_COMPLETED_DELAY = "completedDelay";
var AUTOCLICK_TYPE_LOAD_DELAY = "loadDelay";
var AUTOCLICK_TYPE_VIEWABLE_DELAY = "viewableDelay";
var AUTOCLICK_TYPE_VIEWABLE_DELAY_WITH_RESET = "viewableDelayWithReset";

var CLICK_OPEN_METHOD_MRAID = "mraid";
var CLICK_OPEN_METHOD_ANCHOR = "anchor";
var CLICK_OPEN_METHOD_LOCATION = "location";

/***/ }),

/***/ 21:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return pointInCTA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return clickAreaTypeFromEvent; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isDeadzoneCoord; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__constants__ = __webpack_require__(2);
function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }

/**
 * Contains logic to determine whether cta was clicked. This is not the optimal
 * way to do it - a better way would be to include CTA location as part of the
 * creative's concept rendering configuration and to set it explicitly.
 */



var pointInEl = function pointInEl(el, x, y) {
  var _el$getBoundingClient = el.getBoundingClientRect(),
      elTop = _el$getBoundingClient.top,
      elRight = _el$getBoundingClient.right,
      elBottom = _el$getBoundingClient.bottom,
      elLeft = _el$getBoundingClient.left;

  return x >= elLeft && x <= elRight && y >= elTop && y <= elBottom;
};

/**
 * Returns true iff (x, y) is within the bounds of a CTA. We
 * consider an element to be a "CTA element" if it's part of the generic-cta or
 * custom-cta components or is in a container that has 'cta' in the id. This can
 * give both false positives (e.g. if a non-CTA image is placed in a CTA
 * container) and false negatives (e.g. if a CTA is embedded in a larger image
 * in one of the "fill" templates), but it's probably close to the best we can
 * do without manual tagging. We include all descendants of cta
 * containers/components, because sometimes their children overflow.
 */
var pointInCTA = function pointInCTA(x, y) {
  return [].concat(_toConsumableArray(document.querySelectorAll([".generic-cta", ".generic-cta *", ".custom-cta", ".custom-cta *", ".cta-container", ".cta-container *", ".liftoff-cta", ".liftoff-cta *", ".product-view-cta .light", ".last-chance-endscreen-container"].join(", ")))).some(function (ctaEl) {
    return pointInEl(ctaEl, x, y);
  });
};

/**
 * Returns true iff e is a MouseEvent that occurred over a CTA.
 */
var clickAreaTypeFromEvent = function clickAreaTypeFromEvent(e) {
  return pointInCTA(e.clientX, e.clientY) ? __WEBPACK_IMPORTED_MODULE_0__constants__["l" /* CLICK_AREA_TYPE_CTA */] : __WEBPACK_IMPORTED_MODULE_0__constants__["m" /* CLICK_AREA_TYPE_OTHER */];
};

var isDeadzoneCoord = function isDeadzoneCoord(_ref) {
  var x = _ref.x,
      y = _ref.y;

  if (!Number.isFinite(x) || !Number.isFinite(y)) {
    console.warn("Unexpected coords", { x: x, y: y });
    return;
  }
  return [].concat(_toConsumableArray(document.body.querySelectorAll(".liftoff-deadzone"))).some(function (el) {
    return pointInEl(el, x, y);
  });
};

/***/ }),

/***/ 38:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__ = __webpack_require__(1);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }



/*
 * ClickInteraction is used to connect elements that respond to clicks
 * with the elements that trigger click events. Primarily, this allows
 * dynamic CTAs to respond to click events on click overlays or any
 * other clickthrough element.
 */

// Global state for two-click CTAs.
var hasBeenClicked = false;
var firstClickHandlers = [];

// Global state for slider CTAs.
var SLIDER_COMPLETION_RATIO = 0.7;
var sliders = [];

var setSlideDistance = function setSlideDistance(value) {
  sliders.forEach(function (_ref) {
    var sliderSize = _ref.sliderSize,
        setSlideRatio = _ref.setSlideRatio;
    return setSlideRatio(value / sliderSize);
  });
};

var getPointerEventX = function getPointerEventX(e) {
  return (e.changedTouches && e.changedTouches[0] || e.touches && e.touches[0] || e).clientX;
};

var ClickInteraction = function () {
  function ClickInteraction() {
    _classCallCheck(this, ClickInteraction);
  }

  _createClass(ClickInteraction, null, [{
    key: "captureFirstClick",
    value: function captureFirstClick(handleFirstClick) {
      firstClickHandlers.push(handleFirstClick);
    }
  }, {
    key: "captureSlideClick",
    value: function captureSlideClick(_ref2) {
      var onCompleted = _ref2.onCompleted,
          sliderSize = _ref2.sliderSize,
          setSlideRatio = _ref2.setSlideRatio;

      sliders.push({ onCompleted: onCompleted, sliderSize: sliderSize, setSlideRatio: setSlideRatio });
    }
  }, {
    key: "addListeners",
    value: function addListeners(clickEl, onClickComplete) {
      clickEl.addEventListener("click", function (e) {
        if (sliders.length > 0) {
          return;
        }

        if (!hasBeenClicked) {
          hasBeenClicked = true;

          if (firstClickHandlers.length > 0) {
            firstClickHandlers.forEach(function (handler) {
              return handler(e);
            });

            return;
          }
        }

        onClickComplete(e);
      }, true);

      var slideStartPosition = null;
      __WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["on"](clickEl, {
        "mousedown touchstart": function mousedownTouchstart(e) {
          slideStartPosition = getPointerEventX(e);
        },
        "mousemove touchmove": function mousemoveTouchmove(e) {
          if (slideStartPosition == null) return;

          setSlideDistance(getPointerEventX(e) - slideStartPosition);
        },
        "mouseup mouseleave touchend": function mouseupMouseleaveTouchend(e) {
          if (slideStartPosition == null) return;

          var slideDistance = getPointerEventX(e) - slideStartPosition;
          var completedSliders = sliders.filter(function (_ref3) {
            var sliderSize = _ref3.sliderSize;
            return slideDistance > sliderSize * SLIDER_COMPLETION_RATIO;
          });

          if (completedSliders.length > 0) {
            completedSliders.forEach(function (_ref4) {
              var onCompleted = _ref4.onCompleted;
              return onCompleted();
            });
            Promise.resolve(onClickComplete(e)).then(function () {
              return new Promise(function (resolve) {
                return setTimeout(resolve, 1000);
              });
            }).then(function () {
              return setSlideDistance(0);
            });
          } else {
            setSlideDistance(0);
          }

          slideStartPosition = null;
        }
      });
    }
  }]);

  return ClickInteraction;
}();

/* harmony default export */ __webpack_exports__["a"] = (ClickInteraction);

/***/ }),

/***/ 39:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addDeadzoneStyles; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__ = __webpack_require__(1);


/** TODO(oscar): This is a temporary solution to add deadzones to CSPs. */
var addDeadzoneStyles = function addDeadzoneStyles() {
  var el = Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["strToElement"])("\n  <style>\n    .liftoff-deadzone.deadzone-experiment {\n      position: absolute;\n      width: max(50px, min(85px, 11vw));\n      height: max(50px, min(85px, 11vw));\n      z-index: 96;\n    }\n    .liftoff-deadzone.top-left {\n      top: 0;\n      left: 0;\n    }\n    .liftoff-deadzone.top-right {\n      top: 0;\n      right: 0;\n    }\n  </style>\n  ");
  document.head.appendChild(el);
};

var addDeadzones = function addDeadzones(useExpandedZones) {
  var rootEl = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : document.body;

  var deadzoneEls = [Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["strToElement"])("<div class=\"liftoff-deadzone top-left\"></div>"), Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["strToElement"])("<div class=\"liftoff-deadzone top-right\"></div>")];
  deadzoneEls.forEach(function (el) {
    if (useExpandedZones) {
      el.classList.add("deadzone-experiment");
    }
    rootEl.appendChild(el);
  });
};

/* harmony default export */ __webpack_exports__["b"] = (addDeadzones);

/***/ }),

/***/ 5:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__adexp__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__error_handling__ = __webpack_require__(10);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__frontendlib_utils__ = __webpack_require__(0);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }





/**
 * Sends log to Adexp.
 */
var postJSON = function postJSON(url, data) {
  /**
   * TODO(oscar): Investigate if we could improve empty payloads.
   * @see https://github.com/liftoffio/liftoff/pull/25293
   */
  if (data == null) {
    console.error("No data to post for logging.");
    return Promise.resolve();
  }
  var payload = JSON.stringify(data);

  if (payload.length < 2) {
    console.error("Data could not be stringified for logging.");
    return Promise.resolve();
  }

  return Object(__WEBPACK_IMPORTED_MODULE_2__frontendlib_utils__["request"])("POST", url, {
    // Don't set the content type to "application/json" because that requires
    // a preflight OPTIONS request (because this is a cross-domain request).
    "Content-Type": "text/plain"
  }, payload).catch(function () {
    console.error("Failed to post JSON for logging.");
  });
};

var postMetricV2 = function postMetricV2(_ref, name, value) {
  var adexpContextSnapshotFn = _ref.adexpContextSnapshotFn,
      endpoint = _ref.endpoint,
      eventTrackingParam = _ref.eventTrackingParam;

  var adexpContext = adexpContextSnapshotFn();
  var payload = new __WEBPACK_IMPORTED_MODULE_0__adexp__["c" /* AdexpMessage */]({
    context: adexpContext,
    metric: new __WEBPACK_IMPORTED_MODULE_0__adexp__["d" /* AdexpMetricV2 */](name, value)
  });

  return postJSON(endpoint + "/adexp_metrics/" + eventTrackingParam, payload);
};

var Logger = function () {
  function Logger() {
    _classCallCheck(this, Logger);
  }

  _createClass(Logger, null, [{
    key: "init",

    // #if process.env.NODE_ENV === "test"
    //   static resetForTests() {
    //     delete this.enabled;
    //     delete this.loggedErrors;
    //     delete this.endpoint;
    //     delete this.eventTrackingParam;
    //     delete this.adexpContextSnapshotFn;
    //   }
    // #endif

    value: function init() {
      this.enabled = false;
      this.loggedErrors = [];
    }
  }, {
    key: "enable",
    value: function enable() {
      this.enabled = true;
    }

    /**
     * Pass the logger required context
     * @param {string} endpoint - The endpoint to which the creative will post
     * AdExp logs or metrics.
     * @param {string} eventTrackingParam - The tracking parameter string which
     * includes encoded bid context information.
     * @param {function} adexpContextSnapshotFn - A function to call that will
     * take a snapshot of the current environment and return an `AdexpContext`
     * object.
     */

  }, {
    key: "passContext",
    value: function passContext(endpoint, eventTrackingParam, adexpContextSnapshotFn) {
      this.endpoint = endpoint;
      this.eventTrackingParam = eventTrackingParam;
      this.adexpContextSnapshotFn = adexpContextSnapshotFn;
    }

    /**
     * Listens for errors that are caught by the window and reports them to adexp.
     * Don't call this if you use your own custom error handlers.
     */

  }, {
    key: "addErrorListeners",
    value: function addErrorListeners() {
      var _this = this;

      window.addEventListener("error", function (errorEvent) {
        var normalizedError = Object(__WEBPACK_IMPORTED_MODULE_1__error_handling__["c" /* normalizeErrorEvent */])(errorEvent);
        _this.recordError(normalizedError);
      });
    }

    /**
     * recordError takes an object like:
     * { message, line, column, sourceURL ... }
     * and logs the error to adexp.
     */

  }, {
    key: "recordError",
    value: function recordError(e) {
      this.recordLabeledError("error", e);
    }
  }, {
    key: "recordLabeledError",
    value: function recordLabeledError(tag, e) {
      // #if process.env.NODE_ENV !== "test"
      console.error(e);
      // #endif
      this._processError(tag, e);
    }
  }, {
    key: "_processError",
    value: function _processError(tag, errorObj) {
      if (Object(__WEBPACK_IMPORTED_MODULE_1__error_handling__["e" /* shouldIgnoreError */])(errorObj)) {
        return;
      }

      var normalizedErr = Object(__WEBPACK_IMPORTED_MODULE_1__error_handling__["b" /* normalizeError */])(errorObj);

      // Only log one error per (sourceURL, line #, message) combination. This
      // prevents noise from certain errors that are logged many times
      // from a single impression.
      var errorIdentifier = [normalizedErr.sourceURL, normalizedErr.line, normalizedErr.message].join("-");

      if (this.loggedErrors.includes(errorIdentifier)) {
        return;
      }

      this.loggedErrors.push(errorIdentifier);
      this.recordLog(tag, normalizedErr.message, new __WEBPACK_IMPORTED_MODULE_0__adexp__["a" /* AdexpJavaScriptError */](normalizedErr));
    }
  }, {
    key: "recordLog",
    value: function recordLog(tag, message, data) {
      if (!this.enabled) {
        return;
      }

      var adexpContext = this.adexpContextSnapshotFn();
      var payload = new __WEBPACK_IMPORTED_MODULE_0__adexp__["c" /* AdexpMessage */]({
        context: adexpContext,
        log: new __WEBPACK_IMPORTED_MODULE_0__adexp__["b" /* AdexpLog */](tag, message, data)
      });

      return postJSON(this.endpoint + "/adexp_log/" + this.eventTrackingParam, payload);
    }
  }, {
    key: "recordMetricV2",
    value: function recordMetricV2(name, value) {
      if (!this.enabled) {
        return Promise.resolve();
      }
      return postMetricV2({
        endpoint: this.endpoint,
        eventTrackingParam: this.eventTrackingParam,
        adexpContextSnapshotFn: this.adexpContextSnapshotFn
      }, name, value);
    }
  }, {
    key: "recordVXOnlyAdexpMetric",
    value: function recordVXOnlyAdexpMetric(name, value) {
      if (!Number.isInteger(value)) {
        console.debug("Expected an integer value for VXOnlyAdexpMetric: " + name);
        return;
      }

      return this.alwaysRecordMetricV2("custom_event", {
        name: name,
        value: value
      });
    }
  }, {
    key: "alwaysRecordMetricV2",
    value: function alwaysRecordMetricV2(name, value) {
      return postMetricV2({
        endpoint: this.endpoint,
        eventTrackingParam: this.eventTrackingParam,
        adexpContextSnapshotFn: this.adexpContextSnapshotFn
      }, name, value);
    }
  }]);

  return Logger;
}();

// TODO(oscar): Create a global Logger.


Logger.init();

/* harmony default export */ __webpack_exports__["a"] = (Logger);

/***/ }),

/***/ 66:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__frontendlib_event_listener__ = __webpack_require__(11);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__lib_click_interaction__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__container__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__cta__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__liftoff_mraid__ = __webpack_require__(12);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__addDeadzones__ = __webpack_require__(39);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }












var Madlib = function () {
  function Madlib() {
    _classCallCheck(this, Madlib);
  }

  _createClass(Madlib, null, [{
    key: "init",
    value: function init() {
      __WEBPACK_IMPORTED_MODULE_2__frontendlib_event_listener__["a" /* default */].pubsubify(this);

      this.rootEl = null;
      this.config = null;

      this.loaded = false;
      this.containerByID = {};
      this.allContainers = [];
      this.rootContainer = null;

      // TODO(vsingh): Remove hacky global once we are more clear on how Madlib resize events should
      //   be handled.
      this.didEverApplyLetterboxStyles = false;

      this.productIndex = 0;

      this.on("navigation-click", function (queryParams, clickAreaType) {
        Liftoff.handleClick(queryParams, clickAreaType);
      });
    }

    /**
     * Returns a product cycling indefinitely.
     */

  }, {
    key: "getNextProduct",
    value: function getNextProduct() {
      var _Liftoff$env$products = Liftoff.env.products,
          products = _Liftoff$env$products === undefined ? [] : _Liftoff$env$products;
      var productIndex = this.productIndex;

      this.productIndex += 1;

      return products[productIndex % products.length];
    }
  }, {
    key: "error",
    value: function error() {
      var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : new Error("Unspecified Madlib error.");

      Liftoff.handleMadlibError(e);
    }
  }, {
    key: "load",
    value: function load(rootEl, config) {
      this.rootEl = rootEl;
      this.config = config;
      this.applyExchangePolicies();
      this.loadDOM();
      this.addEventListeners();
      this.coordinate();
      this.layout();

      Liftoff.onLoadCompleted();
    }
  }, {
    key: "applyExchangePolicies",
    value: function applyExchangePolicies() {
      var animationDurationLimit = Liftoff.getAnimationDurationLimit();
      if (animationDurationLimit > 0) {
        setTimeout(function () {
          Madlib.allContainers.forEach(function (container) {
            var content = container.content;

            if (content == null) return;
            container.layout().then(function () {
              content.stop();
            });
          });
        }, animationDurationLimit);
      }
    }
  }, {
    key: "loadDOM",
    value: function loadDOM() {
      var _this = this;

      this.layoutEl = document.createElement("div");
      this.layoutEl.id = "liftoff-layout";
      this.rootEl.appendChild(this.layoutEl);

      this.clickEl = document.createElement("div");
      this.clickEl.id = "liftoff-click";
      __WEBPACK_IMPORTED_MODULE_3__lib_click_interaction__["a" /* default */].addListeners(this.clickEl, function (e) {
        _this.handleNavigationClick(e);
      });
      this.rootEl.appendChild(this.clickEl);

      var _Liftoff$bidContext = Liftoff.bidContext,
          is_interstitial = _Liftoff$bidContext.is_interstitial,
          is_reengagement = _Liftoff$bidContext.is_reengagement;
      // TODO(oscar): Cleanup test code once crserve-deadzone experiment is over.

      var isDeadzoneExperiment = Liftoff.hasTestGroup("crserve-deadzone-v2-experiment");
      var useDeadzones = is_interstitial && (!is_reengagement || isDeadzoneExperiment);
      if (useDeadzones) {
        Object(__WEBPACK_IMPORTED_MODULE_7__addDeadzones__["b" /* default */])(isDeadzoneExperiment, this.rootEl);
      }
    }
  }, {
    key: "handleNavigationClick",
    value: function handleNavigationClick(e) {
      var queryParams = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

      this.emit("navigation-click", queryParams, Object(__WEBPACK_IMPORTED_MODULE_5__cta__["a" /* clickAreaTypeFromEvent */])(e));
    }
  }, {
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;

      window.addEventListener("resize", function () {
        _this2.layout();
      });
    }
  }, {
    key: "coordinate",
    value: function coordinate() {
      this.on("wait", function (_ref) {
        var timeMS = _ref.timeMS;

        return new Promise(function (resolve) {
          return setTimeout(resolve, Number(timeMS));
        });
      });
    }
  }, {
    key: "getEvents",
    value: function getEvents() {
      return [{ name: "beforeVisible" }].map(function (e) {
        e.type = "madlib";
        return e;
      });
    }
  }, {
    key: "getActions",
    value: function getActions() {
      return [{
        name: "wait",
        data: ["timeMS"]
      }].map(function (a) {
        a.type = "madlib";
        return a;
      });
    }
  }, {
    key: "getCreativeConfig",
    value: function getCreativeConfig() {
      // TODO(cory) Implement rendering for multiple scenes. For now, all configs have exactly one scene.
      return this.config.scenes[0].layoutContent;
    }
  }, {
    key: "configureLetterbox",
    value: function configureLetterbox(letterboxConfig) {
      var useDarkRootBackground = letterboxConfig.useDarkRootBackground();
      var useLayoutBackground = letterboxConfig.useLayoutBackground();

      this.rootEl.classList.toggle("letterbox-dark-background", useDarkRootBackground);
      this.layoutEl.classList.toggle("letterbox-layout-background", useLayoutBackground);

      this.didEverApplyLetterboxStyles = true;

      Object.assign(this.clickEl.style, letterboxConfig.getStyleForClickElement());
    }
  }, {
    key: "layout",
    value: function layout() {
      var _this3 = this;

      if (this.rootContainer != null) {
        this.rootContainer.invalidate();
      }

      this.reset();

      var letterboxConfig = Liftoff.getLetterboxConfig();
      var rootElementConstraints = null;

      if (letterboxConfig.enabled()) {
        this.configureLetterbox(letterboxConfig);
        rootElementConstraints = letterboxConfig.getLetterboxConstraintsForMadlibRootElement();
      }

      this.parseCreativeConfig(this.layoutEl, this.getCreativeConfig(), rootElementConstraints);

      var allContainers = this.allContainers,
          rootContainer = this.rootContainer;


      var loaded = rootContainer.loadContent().catch(function (e) {
        return _this3.error(e);
      });

      var ready = rootContainer.layout().then(function () {
        __WEBPACK_IMPORTED_MODULE_6__liftoff_mraid__["a" /* default */].onViewable(function () {
          if (rootContainer.invalidated) return;
          allContainers.forEach(function (_ref2) {
            var content = _ref2.content;

            if (content) content.start();
          });
        });
      }).catch(function (e) {
        return _this3.error(e);
      });

      Promise.all([loaded, ready]).then(function () {
        if (!_this3.loaded) {
          _this3.loaded = true;
          Liftoff.onMadlibLoaded();
          _this3.emit("beforeVisible");
          Liftoff.onFirstLayoutFinished();
        }
      });
    }
  }, {
    key: "reset",
    value: function reset() {
      this.productIndex = 0;
      // TODO(brian): Teardown existing components here.
      Liftoff.resetClickParams();
      this.clickEl.classList.remove("active");
      Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["empty"])(this.layoutEl);
      if (this.didEverApplyLetterboxStyles) {
        [this.layoutEl, this.clickEl].forEach(function (el) {
          ["left", "top", "width", "height", "right", "bottom", "transform"].forEach(function (prop) {
            el.style[prop] = "";
          });
        });
      }
    }
  }, {
    key: "parseCreativeConfig",
    value: function parseCreativeConfig(rootEl, config, rootElementConstraints) {
      var _this4 = this;

      var componentParams = config.componentParams;

      var clickTargets = config.clickTargets,
          constraints = config.constraints,
          containers = config.containers,
          coordination = config.coordination,
          css = config.css;

      var _ref3 = rootElementConstraints || {},
          rootConstraints = _ref3.rootConstraints,
          rootPostLayoutTransform = _ref3.rootPostLayoutTransform;

      var traverse = function traverse(parent, _ref4) {
        var id = _ref4.id,
            children = _ref4.children;

        var container = new __WEBPACK_IMPORTED_MODULE_4__container__["a" /* default */](document.createElement("div"), id);
        container.parent = parent;
        container.children = (children || []).map(traverse.bind(null, container));
        container.css = css[id];
        container.constraints = constraints[id];
        if (componentParams[id] != null) {
          var _componentParams$id = componentParams[id],
              component = _componentParams$id.component,
              params = _componentParams$id.params;

          var subcomponents = [];
          var fixValues = function fixValues(params) {
            Object.keys(params).forEach(function (key) {
              var _params$key = params[key],
                  type = _params$key.type,
                  value = _params$key.value;

              if (value != null) {
                switch (type) {
                  case "array":
                    params[key].value = value.map(fixValues);
                    break;
                  case "image_original":
                  case "video_original":
                    params[key].value = Liftoff.resolveAsset(type, value);
                    break;
                  case "component":
                    var componentName = value.component;
                    var _componentParams = fixValues(Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["clone"])(value.params));
                    var _component = Liftoff.Component.new(componentName, _componentParams);
                    params[key].value = _component;
                    subcomponents.push(_component);
                    break;
                }
              }

              params[key] = params[key].value;
            });
            return params;
          };

          params = fixValues(Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["clone"])(params));
          container.content = Liftoff.Component.new(component, params);
          container.content.on("error", _this4.error.bind(_this4));
          // Errors from all subcomponents, regardless of nesting depth, are
          // relayed directly to the top-level component.
          subcomponents.forEach(function (subcomponent) {
            return subcomponent.relay(container.content, "error");
          });
        }

        _this4.containerByID[id] = container;
        _this4.allContainers.push(container);
        return container;
      };

      this.containerByID = {};
      this.allContainers = [];
      this.rootContainer = new __WEBPACK_IMPORTED_MODULE_4__container__["a" /* default */](rootEl);
      this.rootContainer.parent = new __WEBPACK_IMPORTED_MODULE_4__container__["a" /* default */](rootEl.parentNode);
      this.rootContainer.children = containers.map(traverse.bind(null, this.rootContainer));
      this.rootContainer.css = { overflow: "hidden" };
      this.rootContainer.constraints = rootConstraints || {
        width: "100%",
        height: "100%"
      };
      this.rootContainer.postLayoutTransform = rootPostLayoutTransform;

      this.attachAnchors();
      this.configureCoordination(coordination);
      this.configureClickTargets(clickTargets);

      this.rootContainer.layout();
    }
  }, {
    key: "attachAnchors",
    value: function attachAnchors() {
      var _this5 = this;

      this.allContainers.forEach(function (container) {
        if (container.constraints == null) return;
        container.anchors = ["top", "right", "bottom", "left"].filter(function (edge) {
          return Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["type"])(container.constraints[edge]) === "object";
        }).map(function (edge) {
          return {
            edge: edge,
            anchor: _this5.containerByID[container.constraints[edge].anchor]
          };
        });
      });
    }

    // Link events with actions.

  }, {
    key: "configureCoordination",
    value: function configureCoordination(coordination) {
      var _this6 = this;

      coordination.filter(function (_ref5) {
        var event = _ref5.event;
        return event.name != null;
      }).forEach(function (_ref6) {
        var event = _ref6.event,
            actions = _ref6.actions;
        var eventName = event.name,
            eventType = event.type,
            source = event.source,
            eventMacros = event.data;


        var actors = actions.map(function (action) {
          var actionName = action.name,
              actionType = action.type,
              target = action.target,
              actionMacros = action.data;

          var actor = void 0;
          switch (actionType) {
            case "madlib":
              actor = _this6;
              break;
            case "component":
              actor = _this6.containerByID[target].content;
              break;
            case "container":
              actor = _this6.containerByID[target];
              break;
          }

          return { actionName: actionName, actor: actor, actionMacros: actionMacros };
        }).filter(function (_ref7) {
          var actionName = _ref7.actionName;
          return actionName != null;
        });

        var emitter = void 0;
        switch (eventType) {
          case "madlib":
            emitter = _this6;
            break;
          case "component":
            emitter = _this6.containerByID[source].content;
            break;
          case "container":
            emitter = _this6.containerByID[source];
            break;
        }

        var getMacroValues = function getMacroValues(eventPayload) {
          var macroValues = {};
          Object.keys(eventMacros).forEach(function (key) {
            var macro = eventMacros[key];
            macroValues[macro] = eventPayload[key];
          });

          return macroValues;
        };

        var expandMacros = function expandMacros(macroValues, actionMacros) {
          var actionPayload = {};
          Object.keys(actionMacros).forEach(function (key) {
            var expansion = Object.keys(macroValues).reduce(function (s, macro) {
              // TODO(oscar): Tokenize macro better.
              s = s == null ? "" : s;
              var r = Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["escapeRegExp"])(macro);
              var sub = macroValues[macro] == null ? "" : String(macroValues[macro]);
              return s.replace(new RegExp(r, "g"), sub);
            }, actionMacros[key]);

            actionPayload[key] = expansion;
          });

          return actionPayload;
        };

        var processEventPayload = function processEventPayload(eventPayload, actionMacros) {
          return expandMacros(getMacroValues(eventPayload), actionMacros);
        };

        var dispatchActions = function dispatchActions() {
          var eventPayload = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

          // "Waterfall" the `.emit` Promises to process them serially.
          return actors.reduce(function (promise, _ref8) {
            var actionName = _ref8.actionName,
                actor = _ref8.actor,
                actionMacros = _ref8.actionMacros;

            var data = processEventPayload(eventPayload, actionMacros);
            return promise.then(function () {
              return actor.emit(actionName, data);
            });
          }, Promise.resolve()).catch(function (e) {
            return _this6.error(e);
          });
        };

        emitter.on(eventName, dispatchActions);
      });
    }

    // Setup click listeners.

  }, {
    key: "configureClickTargets",
    value: function configureClickTargets(clickTargets) {
      var _this7 = this;

      if (clickTargets.length > 0) {
        clickTargets.forEach(function (id) {
          __WEBPACK_IMPORTED_MODULE_3__lib_click_interaction__["a" /* default */].addListeners(_this7.containerByID[id].el, function (e) {
            _this7.handleNavigationClick(e);
          });
        });
      }
      // tre HTML endcards have their own way of handling click events.
      else if (!window.Liftoff.env.is_tre || !window.TreSensa) {
          this.clickEl.classList.add("active");
        }
    }
  }]);

  return Madlib;
}();

Madlib.init();

Madlib.ClickInteraction = __WEBPACK_IMPORTED_MODULE_3__lib_click_interaction__["a" /* default */];

window.Madlib = Madlib;

/* harmony default export */ __webpack_exports__["default"] = (Madlib);

/***/ }),

/***/ 67:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__frontendlib_event_listener__ = __webpack_require__(11);
var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





var EDGE_TO_TYPE = {
  left: "leading",
  right: "trailing",
  top: "leading",
  bottom: "trailing"
};
var EDGE_TO_DIMENSION = {
  left: "width",
  right: "width",
  top: "height",
  bottom: "height"
};

// We currently require CTA containers to be prefixed with "CTA", but we're
// more liberal here to support some legacy templates.
var ctaContainerRegex = /\bcta\b/i;
var isCTAContainer = function isCTAContainer(containerID) {
  return ctaContainerRegex.test(containerID);
};

var Container = function (_EventListener) {
  _inherits(Container, _EventListener);

  _createClass(Container, null, [{
    key: "getEvents",
    value: function getEvents() {
      return [{ name: "beforeLayout", system: true }, { name: "onClick" }].map(function (e) {
        e.type = "container";
        return e;
      });
    }
  }, {
    key: "getActions",
    value: function getActions() {
      return [{ name: "show" }, { name: "hide" }].map(function (a) {
        a.type = "container";
        return a;
      });
    }

    /** @param {HTMLDivElement} el - The container element. */

  }]);

  function Container(el) {
    var id = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";

    _classCallCheck(this, Container);

    var _this = _possibleConstructorReturn(this, (Container.__proto__ || Object.getPrototypeOf(Container)).call(this));

    _this.el = el;
    _this.el.classList.add("madlib-container");
    if (isCTAContainer(id)) {
      // We tag CTA containers to help us detect when clicks occur on CTAs.
      _this.el.classList.add("cta-container");
    }
    // `parent` and `children` refer to other Containers.
    _this.parent = null;
    _this.children = [];

    _this.fixedWidth = false;
    _this.fixedHeight = false;

    _this.css = null;
    _this.constraints = null;
    _this.anchors = [];
    _this.content = null;

    _this.layoutReady = null;
    _this.contentReady = null;
    _this.hidden = false;

    _this.postLayoutTransform = null;

    _this.addEventListeners();
    _this.coordinate();
    return _this;
  }

  _createClass(Container, [{
    key: "addEventListeners",
    value: function addEventListeners() {
      var _this2 = this;

      this.el.addEventListener("click", function () {
        return _this2.emit("onClick");
      });
    }
  }, {
    key: "coordinate",
    value: function coordinate() {
      var _this3 = this;

      this.on({
        hide: function hide() {
          Object.assign(_this3.el.style, {
            pointerEvents: "none",
            visibility: "hidden"
          });
        },
        show: function show() {
          Object.assign(_this3.el.style, {
            pointerEvents: _this3.css && _this3.css["pointer-events"] || "auto",
            visibility: _this3.css && _this3.css.visibility || "visible"
          });
        }
      });
    }
  }, {
    key: "loadContent",
    value: function loadContent() {
      if (this.contentReady == null) {
        var promises = this.children.map(function (child) {
          return child.loadContent();
        });
        if (this.content != null) {
          promises.push(this.content.load());
        }

        this.contentReady = Promise.all(promises);
      }

      return this.contentReady;
    }
  }, {
    key: "layout",
    value: function layout() {
      var _this4 = this;

      if (this.layoutReady == null) {
        // NOTE(oscar): beforeLayout should probably only trigger at most once per
        // container.
        this.emit("beforeLayout");
      }
      if (this.layoutReady == null) {
        if (this.el.parentNode !== this.parent.el) {
          this.parent.el.appendChild(this.el);
        }

        if (this.constraints != null) {
          if (this.constraints.left != null && this.constraints.right != null || this.constraints.width != null) {
            this.fixedWidth = true;
          }

          if (this.constraints.top != null && this.constraints.bottom != null || this.constraints.height != null) {
            this.fixedHeight = true;
          }
        }

        // The child components do not layout properly if a transform is active.
        // So, let's reset the transform before we proceed, then apply it later.
        this.resetTransform();

        this.style();
        this.position();
        this.layoutReady = this.loadContent().then(function () {
          return _this4.anchor();
        }).then(function () {
          return _this4.match();
        }).then(function () {
          return _this4.layoutContent();
        }).then(function () {
          return _this4.center();
        }).then(function () {
          return _this4.applyTransform();
        });
      }

      return this.layoutReady;
    }
  }, {
    key: "style",
    value: function style() {
      // The zIndex creates a stacking context for the contents of the container
      // element so that they don't interfere with other containers.
      Object.assign(this.el.style, { zIndex: 1 }, this.css);
    }
  }, {
    key: "position",
    value: function position() {
      var _this5 = this;

      if (this.constraints == null) return;
      var styles = { position: "absolute" };
      ["top", "bottom", "left", "right", "width", "height"].forEach(function (prop) {
        var value = _this5.constraints[prop];
        if (value != null && Object(__WEBPACK_IMPORTED_MODULE_1__frontendlib_utils__["type"])(value) !== "object") {
          styles[prop] = value;
        }
      });
      Object.assign(this.el.style, styles);
    }
  }, {
    key: "resetTransform",
    value: function resetTransform() {
      if (this.postLayoutTransform != null) {
        this.el.style.transform = "none";
      }
    }
  }, {
    key: "applyTransform",
    value: function applyTransform() {
      if (this.postLayoutTransform != null) {
        this.el.style.transform = this.postLayoutTransform;
      }
    }
  }, {
    key: "anchor",
    value: function anchor() {
      var _this6 = this;

      var pRect = void 0;
      var promises = this.anchors.map(function (_ref) {
        var containerEdge = _ref.edge,
            anchor = _ref.anchor;
        var _constraints$containe = _this6.constraints[containerEdge],
            distance = _constraints$containe.distance,
            anchorEdge = _constraints$containe.edge;

        var containerEdgeType = EDGE_TO_TYPE[containerEdge];
        var anchorEdgeType = EDGE_TO_TYPE[anchorEdge];
        var dimension = EDGE_TO_DIMENSION[containerEdge];
        // Block positioning until the anchor is ready.
        return anchor.layout().then(function () {
          if (pRect == null) {
            pRect = _this6.parent.el.getBoundingClientRect();
          }

          var rect = Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["getRelativeBoundingClientRect"])(anchor.el);
          var offset = void 0;
          switch (containerEdgeType + " " + anchorEdgeType) {
            case "leading leading":
              offset = rect[anchorEdge];
              break;
            case "trailing trailing":
              offset = -rect[anchorEdge];
              break;
            case "leading trailing":
              offset = pRect[dimension] + rect[anchorEdge];
              break;
            case "trailing leading":
              offset = pRect[dimension] - rect[anchorEdge];
              break;
          }

          var _parseCSSLength = Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["parseCSSLength"])(distance),
              value = _parseCSSLength.value,
              units = _parseCSSLength.units;

          switch (units) {
            case "px":
              offset += value;
              break;
            case "%":
              offset += pRect[dimension] * value / 100;
              break;
          }

          _this6.el.style[containerEdge] = offset + "px";
        });
      });
      return Promise.all(promises);
    }
  }, {
    key: "match",
    value: function match() {
      if (this.constraints == null || !(this.constraints.matchWidthToHeight || this.constraints.matchHeightToWidth)) {
        return;
      }

      var _el$getBoundingClient = this.el.getBoundingClientRect(),
          width = _el$getBoundingClient.width,
          height = _el$getBoundingClient.height;

      if (this.constraints.matchWidthToHeight) {
        this.el.style.width = height + "px";
      } else if (this.constraints.matchHeightToWidth) {
        this.el.style.height = width + "px";
      }
    }
  }, {
    key: "layoutContent",
    value: function layoutContent() {
      var _this7 = this;

      if (this.invalidated) return;

      var promises = this.children.map(function (child) {
        return child.layout();
      });
      if (this.content != null) {
        promises.push(this.content.layout(this.el));
      }

      return Promise.all(promises).then(function () {
        // For containers that serve as wrappers for other containers (i.e. do not
        // have content), calculate the aggregate bounding rectangle for all
        // children and resize the container to match the rectangle. This allows
        // centering to work properly.
        if (_this7.content != null || _this7.fixedWidth && _this7.fixedHeight) return;
        var rect = Object(__WEBPACK_IMPORTED_MODULE_0__frontendlib_dom_utils__["getAggregateBoundingClientRect"])(_this7.children.map(function (child) {
          return child.el;
        }));
        var style = {};
        if (!_this7.fixedWidth) {
          style.width = rect.width + "px";
        }

        if (!_this7.fixedHeight) {
          style.height = rect.height + "px";
        }

        Object.assign(_this7.el.style, style);
      });
    }
  }, {
    key: "center",
    value: function center() {
      if (this.constraints == null || !(this.constraints.centerHorizontal || this.constraints.centerVertical)) {
        return;
      }

      var pRect = this.parent.el.getBoundingClientRect();
      var rect = this.el.getBoundingClientRect();
      if (this.constraints.centerHorizontal) {
        this.el.style.left = (pRect.width - rect.width) / 2 + "px";
      }

      if (this.constraints.centerVertical) {
        this.el.style.top = (pRect.height - rect.height) / 2 + "px";
      }
    }
  }, {
    key: "invalidate",
    value: function invalidate() {
      this.invalidated = true;

      // NOTE(vsingh):
      // The following is a hack on top of a hack. We invalidate containers when
      // resetting layout, so that any asynchronous process kicked off
      // by those containers will have no further effect.
      // Unfortunately the invalidation hack has holes: there are still
      // cases where side effects are applied to the DOM element
      // associated with the container. Therefore, dissociate the
      // container and the DOM element immediately upon container
      // invalidation.
      this.el = document.createElement("div");
    }
  }]);

  return Container;
}(__WEBPACK_IMPORTED_MODULE_2__frontendlib_event_listener__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (Container);

/***/ })

/******/ });


// WEBPACK FOOTER //
// madlib-6e38ae30a47ade1396c1.js